import * as deepmerge from "deepmerge";
import EventEmitter from "eventemitter3";
import Handlebars from "handlebars/dist/handlebars.min";
import _ from "lodash";
import moment from "moment";
import qs from "qs";
import { setCompletionState } from "../actions/completionActions";
import ambifi from "../ambifi";
import config from "../config/config";
import env from "../constants/env";
import PlayerPaths from "../constants/paths/playerPaths";
import themes from "../constants/themes";
import PersistenceManagerFactory from "../persistence/PersistenceManagerFactory";
import RuntimeApi from "../runtimeEngine/runtimeApi";
import SyntheticVoiceApi from "../speech/SyntheticVoiceApi";
import state from "../state";
import { injectCustomStyling } from "../utils/config";
import { generateAmbifiFontCss } from "../utils/fontUtils";
import { transformSketchPadImagePathsFromPlayer, transformToActivityPlayer } from "../utils/transformUtils";
import * as Utils from "../utils/utils";
import * as UtilsSystem from "../utils/utilsSystem";
import { generateUUID, getActivityItemHistoryPath, getActivityMetaData, initializeIdsAndVariableState, clearAppState } from "../utils/utils";

import { showAlert, showConfirm, showError } from "./alertActions";
import { initializeDrive, getResourceContentForResourceRef, isResourceReference } from "./drive";

import historyActions from "./historyActions";
import { initializeOrchestrator, setValueIfHasIdOrchestratedSync } from "./orchestrationActions";
import { getDatasourceForRef } from "./datasource";
import * as actionsTimerManager from "./actionsTimerManager";
import * as store from "../utils/store";
import { getIdentityId } from "./user";
import { getQueryStringParam } from "../utils/utils";

const removeMd = require("remove-markdown");

export function handleChangePropertyDisconnected(tree, listIndex, sectionIndex, itemIndex, name, value) {
	console.log("HANDLE CHANGE PROPERTY", listIndex, sectionIndex, itemIndex, name, value);
	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, name), value);
	if (name === "checked") {
		console.log("CHECKED PROPERTY CHANGED", value);
		setCompletionState(state);
	}
	saveLastItemValue(tree, value);
	tree.commit();
}

export function handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, name, value) {

	// if (name !== "value") {
	handleChangePropertyDisconnected(tree, listIndex, sectionIndex, itemIndex, name, value);
	// } else {
	// 	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));
	// 	// console.log("IFTTT VARIABLE VALUE SET REQUEST - handleChangeProperty");
	// 	setValueIfHasIdOrchestratedSync(item, value).then(() => {

	// 		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, name), value);

	// 		ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));

	// 		saveLastItemValue(tree, value);
	// 		tree.commit();

	// 		// Moved this down as it might be looking at the node value
	// 		if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
	// 			// Inject global procedure functions	
	// 			let strfun = tree.get(PlayerPaths.ACTIVITY_PROPERTY("functions"));
	// 			let strEval = item.valueTrigger;
	// 			if (!_.isEmpty(strfun)) {
	// 				strEval = strfun + "\n" + item.valueTrigger;
	// 			}

	// 			let AmbiFi = RuntimeApi; // eslint-disable-line
	// 			var af = RuntimeApi; // eslint-disable-line
	// 			var afState = state; // eslint-disable-line
	// 			var afUtils = Utils; // eslint-disable-line
	// 			var afAlert = showAlert; // eslint-disable-line
	// 			eval(strEval);// eslint-disable-line

	// 			//tree.set(["session"], tree.get(["session"]) + 1);
	// 		}
	// 	});
	// }
}

// TODO: UGLY...re-think
export function saveLastItemValue(tree, value) {
	tree.set(["lastItemValue"], value);
}

export function showImagePreview(tree = state, imageUri) {
	tree.set(["appState", "showImagePreview"], true);
	tree.set(["appState", "showImagePreviewUri"], imageUri);
}

export function hideImagePreview(tree = state) {
	tree.set(["appState", "showImagePreview"], false);
	tree.set(["appState", "showImagePreviewUri"], null);
}

export function showVideoPreview(tree = state, videoUri) {
	tree.set(["appState", "showVideoPreview"], true);
	tree.set(["appState", "showVideoPreviewUri"], videoUri);
}

export function hideVideoPreview(tree = state) {
	tree.set(["appState", "showVideoPreview"], false);
	tree.set(["appState", "showVideoPreviewUri"], null);
}

export function setItemChecked(tree, listIndex, sectionIndex, itemIndex, checked, identityId, linkOnCheck, linkId, linkActionType) {
	const historyFunc = checked ? historyActions.checkItem : historyActions.uncheckItem;
	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyFunc, { linkOnCheck, linkId, linkActionType }, { valueType: "checkItem", value: checked }, null, true);
}

export function setNextItemChecked(tree) {
	// // console.log(" In " + arguments.callee.name);
	const listIndex = tree.get(["activity", "selected", "listIndex"]);
	const sectionIndex = tree.get(["activity", "selected", "sectionIndex"]);
	const itemIndex = tree.get(["activity", "selected", "itemIndex"]);

	const item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
	const identityId = tree.get(["user", "identityId"]);

	if (item.type === "itemPicker") {
		const linkOnSelect = (item.hasOwnProperty("pickerLinkOnSelect") ? item.pickerLinkOnSelect : false);
		const linkActionType = (item.hasOwnProperty("pickerLinkActionType") ? item.pickerLinkActionType : "goto");

		if (item.value === "") {
			return;
		}
		setItemPickerChecked(tree, listIndex, sectionIndex, itemIndex, item.value, identityId, linkOnSelect, "", linkActionType);

	} else if (item.type === "itemYesNo") {
		const linkOnSelect = (item.hasOwnProperty("yesNoLinkOnSelect") ? item.yesNoLinkOnSelect : false);
		const linkActionType = (item.hasOwnProperty("yesNoLinkActionType") ? item.yesNoLinkActionType : "goto");
		// const linkYesId = (item.hasOwnProperty("yesNoYesLinkId") ? item.yesNoYesLinkId : "");
		// const linkNoId = (item.hasOwnProperty("yesNoNoLinkId") ? item.yesNoNoLinkId : "");

		if (linkOnSelect && item.value === "") {
			return;
		}
		setItemYesNoChecked(tree, listIndex, sectionIndex, itemIndex, item.value, identityId, linkOnSelect, linkActionType);
	} else {
		const linkOnCheck = (item.hasOwnProperty("linkOnCheck") ? item.linkOnCheck : false);
		const linkId = (item.hasOwnProperty("linkId") ? item.linkId : "");
		const linkActionType = (item.hasOwnProperty("linkActionType") ? item.linkActionType : "goto");

		switch (item.type) {
			case "item":
				setItemChecked(tree, listIndex, sectionIndex, itemIndex, true, identityId, linkOnCheck, linkId, linkActionType);
				break;
			case "itemChoiceSingle": {

				let selectedChoiceItem = {};

				for (let choiceItem in item.choiceItems) {
					if (choiceItem.value === item.value) {
						selectedChoiceItem = choiceItem;
					}
				}

				setItemChoiceSingleChecked(tree, listIndex, sectionIndex, itemIndex, item.value, selectedChoiceItem, identityId, linkOnCheck, linkId, linkActionType);
				break;
			}
			case "itemChoiceMulti":
				setItemChoiceMultiChecked(tree, listIndex, sectionIndex, itemIndex, item.value, identityId, linkOnCheck, linkId, linkActionType);
				break;
			case "itemDate":
				setItemDateChecked(tree, listIndex, sectionIndex, itemIndex, item.value, "date", identityId, linkOnCheck, linkId, linkActionType);
				break;
			case "itemTime":
				setItemDateChecked(tree, listIndex, sectionIndex, itemIndex, item.value, "time", identityId, linkOnCheck, linkId, linkActionType);
				break;
			case "itemDateTime":
				setItemDateChecked(tree, listIndex, sectionIndex, itemIndex, item.value, "datetime", identityId, linkOnCheck, linkId, linkActionType);
				break;
			case "itemWeather":
				setItemWeatherChecked(tree, listIndex, sectionIndex, itemIndex, item.value, identityId, linkOnCheck, linkId, linkActionType);
				break;
			case "itemLocation":
			case "itemAddress":
				setItemLocationChecked(tree, listIndex, sectionIndex, itemIndex, item.value, identityId, linkOnCheck, linkId, linkActionType);
				break;
			case "itemBarcodeScanner":
				setItemBarcodeChecked(tree, listIndex, sectionIndex, itemIndex);
				break;
			case "itemTextInput":
			case "itemTextInputMultiline":
				//setItemTextInputChecked(tree, listIndex, sectionIndex, itemIndex, tree.get(["lastItemValue"]), identityId, linkOnCheck, linkId, linkActionType);
				setItemTextInputChecked(tree, listIndex, sectionIndex, itemIndex, item.value, identityId, linkOnCheck, linkId, linkActionType);
				// Signature for props
				//setItemTextInputChecked(tree, listIndex, sectionIndex, itemIndex, linkOnCheck, linkId, linkActionType)
				break;
			case "itemImagePicker":
				// TODO: Centralize this
				tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex, "checked"], true);

				setCompletionState(tree);

				if (linkOnCheck) {
					linkUrl(tree, linkActionType + ":" + linkId, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex });
				} else {
					setNextSelected(tree, listIndex, sectionIndex, itemIndex);
					//saveCurrentChecklistToStore(tree);
				}
				break;
			// case "itemSketchPad":
			// 	setItemSketchPadChecked(tree, listIndex, sectionIndex, itemIndex);
			// 	break;
			default: {
				console.error("Unknown item type", item);
			}
		}
	}
}

export function skipItem(tree) {

	let listIndex = tree.get(["activity", "selected", "listIndex"]);
	let sectionIndex = tree.get(["activity", "selected", "sectionIndex"]);
	let itemIndex = tree.get(["activity", "selected", "itemIndex"]);

	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "skipped"), true);

	// Force move forward when skipping
	// Better way would be to look forward starting at next item
	/*
	var oldMoveForward = tree.get("moveForward");
	setMoveForward(tree, true);
	*/
	historyActions.skipItem(tree, listIndex + "," + sectionIndex + "," + itemIndex);

	setCompletionState(tree);
	let voices = tree.get(["appPreferences", "voice", "voices"]);
	if (voices) {
		SyntheticVoiceApi.stop();
		// Move to Actions
		// if (!item.selected) {
		// 	// const prevItem = playerActions.getPreviousItem(this.context.tree, this.props.listIndex, this.props.sectionIndex, this.props.itemIndex);
		// 	// console.log("PREV ITEM", prevItem);
		// 	// if (prevItem && prevItem.selected) {
		SyntheticVoiceApi.setDefaultVoice(voices.secondary);
		SyntheticVoiceApi.speak(tree.get(["content"]).mira.responses.skip);
		SyntheticVoiceApi.setDefaultVoice(voices.primary);
		// 	// }
		// }
	}
	setNextSelected(tree, listIndex, sectionIndex, itemIndex + 1);
}

let mandatoryFirstOne = true;
export function refreshMandatory(tree) {
	// // console.log(" In " + arguments.callee.name);
	// Recurse activity
	// First item get to where mandatory = true and checked = false mark enabled true
	// Mark all other items after that enabled = false
	let lists = tree.get(["activity", "children"]);
	// console.log("Dealing with mandatory refresh", lists);
	mandatoryFirstOne = true;
	refreshMandatoryRecurse(lists, tree, 0, 0);
}

function refreshMandatoryRecurse(arr, tree, listIndex, sectionIndex) {
	// // console.log(" In " + arguments.callee.name);
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			tree.set(["activity", "children", i, "enabled"], true);
			listIndex = i;
		} else if (arr[i].type === "section") {
			tree.set(["activity", "children", listIndex, "children", i, "enabled"], true);
			sectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			// console.log("Look at items?", listIndex, tree.get(["activity", "selectedListIndex"]));
			if (listIndex === tree.get(["activity", "selectedListIndex"])) {
				const path = ["activity", "children", listIndex, "children", sectionIndex, "children", i, "enabled"];
				if (arr[i].mandatory && !arr[i].checked) {
					// console.log("Unchecked mandatory found", path);
					if (mandatoryFirstOne) {
						mandatoryFirstOne = false;
						tree.set(path, true);
					} else {
						// console.log("Disable", path);
						tree.set(path, false);
					}
				} else {
					tree.set(path, mandatoryFirstOne);
				}
			}
		}

		if (arr[i].hasOwnProperty("children")) {
			refreshMandatoryRecurse(arr[i].children, tree, listIndex, sectionIndex);
		}
	}
}

// function saveCurrentActivityToStore(tree = state, listIndex, sectionIndex, itemIndex) {
// 	ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));
// }

// export function setItemCheckedForShowMode(tree, listIndex, sectionIndex, itemIndex, identityId) {
// 	debugger;
// 	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyActions.checkItem, {}, { valueType: "checkItem", value: true }).then(() => {
// 		saveCurrentActivityToStore(tree, listIndex, sectionIndex, itemIndex);
// 	});
// }

export function setItemCheckedForShowMode(tree, listIndex, sectionIndex, itemIndex, identityId) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "checked"), true);
	historyActions.checkItem(tree, listIndex + "," + sectionIndex + "," + itemIndex, identityId, tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));
	setCompletionState(tree, listIndex, sectionIndex, itemIndex);

	ambifi.persistenceManager.saveResponse(tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));
	//TODO: save on each swipe?
	//saveCurrentActivityToStore(tree);
}


// Was broken. Reverting to old show mode code for now.
// export function setItemCheckedForShowMode(tree, listIndex, sectionIndex, itemIndex, identityId) {
// 	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyActions.checkItem, {}, { valueType: "checkItem", value: true }).then(() => {
// 		saveCurrentActivityToStore(tree, listIndex, sectionIndex, itemIndex);
// 	});
// }
export function setItemYesNoChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId, linkOnSelect, linkActionType, linkId, forceNav = false) {
	let stopAudio = true;
	const item = Utils.getItem(tree, listIndex, sectionIndex, itemIndex);
	if (!forceNav && !item.suppressAudioValue) {
		let speakValue = "";
		if (value === "yes") {
			speakValue = tree.get(["content"]).items.yesNo.yes;
		} else if (value === "no") {
			speakValue = tree.get(["content"]).items.yesNo.no;
		} else if (value === "na") {
			speakValue = tree.get(["content"]).items.yesNo.na;
		}

		const speak = speakValue;
		SyntheticVoiceApi.stop();
		SyntheticVoiceApi.speak(speak);
		stopAudio = false;
	}
	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyActions.setYesNo, { linkOnSelect, linkActionType, linkId, forceNav, canAdvanceOnSelect: true, autoAdvancePropName: "yesNoAdvanceOnSelect" }, value, null, stopAudio);
}

export function setItemTextInputChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId, linkOnCheck, linkId, linkActionType) {
	const item = Utils.getItem(tree, listIndex, sectionIndex, itemIndex);

	// Signature for props
	//export function setItemTextInputChecked(tree, listIndex, sectionIndex, itemIndex, linkOnCheck, linkId, linkActionType) {
	//var value = tree.get(["currentChecklist", "children", listIndex, "children", sectionIndex, "children", itemIndex, "value"]);
	console.log("SET ITEM TEXTINPUT CHECKED");
	if (value === null) {
		value = "";
	}

	// if (value === "") {
	// 	return;
	// }

	value = Utils.resolveVars(value);

	// TODO: not great...because using state needed a way to also have current state at a higher level
	// Removing...hopefully doesn't break anything
	// const lastItemValue = tree.get(["lastItemValue"]);

	// if (value === "" && lastItemValue !== "") {
	// 	value = lastItemValue;
	// }

	if (!_.isString(value)) {
		value = "" + value;
	}

	if (!item.suppressAudioValue && item.type && item.type.toLowerCase() !== "itemtextinputmultiline") {
		SyntheticVoiceApi.stop();
		SyntheticVoiceApi.speak(value);
	}

	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyActions.setTextInput, { linkOnCheck, linkActionType, linkId }, value).then(() => {
		tree.set(["lastItemValue"], "");
	});
}

export function setItemPickerChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId, linkOnSelect, linkId = "", linkActionType, speak = false, forceNav = false, forceSpeak = false) {
	if (linkId === "") {
		linkId = value;
	}

	const item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
	let pickerItems = item.pickerItems;

	if (_.isEmpty(pickerItems) && !_.isEmpty(item.pickerItemsDatasource)) {
		// Dynamic item
		// const activity = tree.get(["currentChecklist"]);
		const labelKeys = item.pickerItemsDatasource.labelKeys;
		const valueKey = item.pickerItemsDatasource.valueKeys[0];

		const ds = getDatasourceForRef(item.pickerItemsDatasource.refId);
		if (ds && ds.content) {
			// console.log(ds);
			pickerItems = ds.content.map(entry => {
				const labelParts = labelKeys.map(labelKey => {
					return entry[labelKey];
				});

				return {
					label: labelParts.join(" "),
					value: entry[valueKey]
				};
			});
		}
	}

	const label = Utils.getPickerLabelforValue(pickerItems, value);
	const advanceOnSelect = item.hasOwnProperty("pickerAdvanceOnSelect") && item.pickerAdvanceOnSelect;
	if (((advanceOnSelect || speak) && !forceNav) || forceSpeak) {
		// Last check to make sure audio is not surpressed
		if (!item.suppressAudioValue) {
			SyntheticVoiceApi.stop();
			SyntheticVoiceApi.speak(label);
		}
	}

	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyActions.setPicker, { linkOnSelect, linkActionType, linkId, forceNav, advanceOnSelect, canAdvanceOnSelect: true, autoAdvancePropName: "pickerAdvanceOnSelect" }, value, label);
}

export function setItemRankingChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId, linkOnSelect, linkId = "", linkActionType = "goto", speak = false) {
	const _value = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex, "value"]);

	if (linkId === "") {
		linkId = _value;
	}

	const item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
	let items = item.items;

	if (_.isEmpty(items) && !_.isEmpty(item.itemsDatasource)) {
		// Dynamic item
		const labelKeys = item.itemsDatasource.labelKeys;
		const valueKey = item.itemsDatasource.valueKeys[0];

		const ds = getDatasourceForRef(item.itemsDatasource.refId);
		if (ds && ds.content) {
			// console.log(ds);
			items = ds.content.map(entry => {
				const labelParts = labelKeys.map(labelKey => {
					return entry[labelKey];
				});

				return {
					label: labelParts.join(" "),
					value: entry[valueKey]
				};
			});
		}
	}

	const label = Utils.getPickerLabelforValue(items, _value);

	if (speak && !item.suppressAudioValue) {
		SyntheticVoiceApi.speak(label);
	}
	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyActions.setRanking, { linkOnSelect, linkId, linkActionType }, _value, label);
}


export function getValueForItemDate(item, value, mode) {
	let dateString = "";
	let dateString24 = "";
	let valueUtc = "";
	let valueLocale = "";
	if (mode === "date") {
		let _value = Utils.resolveVars(value);

		if (_value !== null && _value !== "") {
			let tempDateTime = "";
			if (_value === "today") {
				tempDateTime = Utils.mcMoment(item);
			} else if (_value !== "") {
				tempDateTime = Utils.mcMoment(item, _value + "T12:00:00");
			}

			valueUtc = tempDateTime.toISOString("YYYY-MM-DD");
			valueLocale = tempDateTime.format("YYYY-MM-DD");
			dateString = tempDateTime.format("MMMM Do YYYY");
			dateString24 = tempDateTime.format("MMMM Do YYYY");
		}
	} else if (mode === "time") {
		let _value = Utils.resolveVars(value);

		if (_value !== null && _value !== "") {
			let tempDateTime = "";

			if (_value === "today") {
				tempDateTime = Utils.mcMoment(item);
			} else if (_value !== "") {
				tempDateTime = Utils.mcMoment(item, Utils.mcMoment(item).format("YYYY-MM-DD") + "T" + _value);
			}

			valueUtc = tempDateTime.format("HH:mm");
			valueLocale = tempDateTime.format("HH:mm");
			dateString = tempDateTime.format("h:mm a");
			dateString24 = tempDateTime.format("H:mm");
		}
	} else if (mode === "datetime") {
		let _value = Utils.resolveVars(value);

		if (_value !== null && _value !== "") {
			let tempDateTime = "";
			if (_value === "today") {
				tempDateTime = Utils.mcMoment(item);
			} else if (_value !== "") {
				tempDateTime = Utils.mcMoment(item, _value);
			}

			valueUtc = tempDateTime.toISOString();
			valueLocale = tempDateTime.format();
			dateString = tempDateTime.format("MMMM Do YYYY, h:mm a");
			dateString24 = tempDateTime.format("MMMM Do YYYY, H:mm");
		}
	}
	console.log("GET DATE VALUE FOR ITEM", item, mode, {
		valueUtc,
		valueLocale,
		dateString,
		dateString24
	});
	return {
		valueUtc,
		valueLocale,
		dateString,
		dateString24
	};
}

export function setItemDateChecked(tree, listIndex, sectionIndex, itemIndex, value, mode, identityId, linkOnCheck, linkId, linkActionType, omitReadValue = false) {
	const item = Utils.getItem(tree, listIndex, sectionIndex, itemIndex);

	const { valueUtc, valueLocale, dateString, dateString24 } = getValueForItemDate(item, value, mode);
	console.log("SUBMIT DATE/TIME", omitReadValue, value, mode);
	// let stopAudio = false;
	if (!omitReadValue && !item.suppressAudioValue) {
		SyntheticVoiceApi.stop();

		if (Utils.hasDateTimeUtc(item)) {
			SyntheticVoiceApi.speak(dateString24 + " Zulu");
		} else {
			SyntheticVoiceApi.speak(dateString);
		}
	}


	const stopAudio = item.dateTimeAdvanceOnSelect !== true && (omitReadValue || item.suppressAudioValue);

	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyActions.setDate, { linkOnCheck, linkActionType, linkId }, [valueLocale, valueUtc], null, stopAudio);
}

export function inlineLinkUrl(link, listIndex, sectionIndex, itemIndex) {
	//inline link will select item	
	setSelectedItem(state, listIndex, sectionIndex, itemIndex, false);
	linkUrl(state, link, { listIndex, sectionIndex, itemIndex });
}

export function setItemLocationChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId, linkOnCheck, linkId, linkActionType) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
	const item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);

	if (!value.hasOwnProperty("address")) {
		tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex, "value"], value);
	}
	tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex, "checked"], true);

	let sessionName;

	if (value.hasOwnProperty("name") && value.hasOwnProperty("address")) {
		if (value.address.startsWith(value.name)) {
			sessionName = value.address;
		} else {
			sessionName = value.name + "\n" + value.address;
		}
	} else if (value.hasOwnProperty("address")) {
		sessionName = value.address;
	} else if (value.hasOwnProperty("name")) {
		sessionName = value.name;
	} else if (value.hasOwnProperty("latitude")) {
		sessionName = "Latitude: " + item.value.latitude + "<br/>Longitude: " + item.value.longitude;
	} else if (value !== "") {
		sessionName = value;
	} else {
		sessionName = "No location";
	}


	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyActions.setLocation, { linkOnCheck, linkId, linkActionType }, value, sessionName);
}

export function setItemChoiceSingleChecked(tree, listIndex, sectionIndex, itemIndex, value, choiceItem, identityId, linkOnCheck, linkId = "", linkActionType) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyActions.setSingleChoice, { linkOnCheck, linkId, linkActionType }, value);
}

export function setItemChoiceMultiChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId, linkOnCheck, linkId, linkActionType) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);

	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyActions.setMultiChoice, { linkOnCheck, linkId, linkActionType }, value);
}

export function setItemImagePickerAddMedia(tree, listIndex, sectionIndex, itemIndex, value, valueUrls, uploaded, identityId) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
	const item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);

	const hasValues = valueUrls && _.isArray(valueUrls) && valueUrls.length > 0;

	let lastImageUrl = hasValues ? valueUrls[valueUrls.length - 1] : "";

	if (!item.suppressAudioValue && hasValues) {
		SyntheticVoiceApi.stop();
		if (uploaded) {
			SyntheticVoiceApi.speak("Media added");
		} else {
			SyntheticVoiceApi.speak("There was an issue uploading media");
		}
	}


	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, () => { historyActions.setImagePicker(tree, listIndex + "," + sectionIndex + "," + itemIndex, identityId, item, lastImageUrl); }, {}, { valueType: "checkItem", value: true });
}

export function addMediaAttachmentHistoryEntry(tree, listIndex, sectionIndex, itemIndex, value, valueUrls, uploaded, identityId) {
	const lastImageUrl = valueUrls ? valueUrls[valueUrls.length - 1] : null;
	historyActions.setMediaAttachment(tree, getActivityItemHistoryPath(listIndex, sectionIndex, itemIndex), lastImageUrl, identityId, tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex)));
}

export function setItemBarcodeChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId) {
	const item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);

	if (!item.suppressAudioValue) {
		SyntheticVoiceApi.stop();
		if (item.hasOwnProperty("barcode") && item.barcode !== null && item.barcode.hasOwnProperty("data") && item.barcode.data !== "") {
			SyntheticVoiceApi.speak("Barcode added.");
		} else {
			SyntheticVoiceApi.speak("The barcode has no data.");
		}
	}

	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyActions.setBarcode, {}, value);
}

export function setItemWeatherChecked(tree, listIndex, sectionIndex, itemIndex, value, identityId, linkOnCheck, linkId, linkActionType) {
	if (value === null) {
		value = "";
	}
	value = Utils.resolveVars(value);
	submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyActions.setWeather, { linkOnCheck, linkActionType, linkId }, value);
}

export function setItemSketchPadChecked(tree, listIndex, sectionIndex, itemIndex) {
	submitItemValue(listIndex, sectionIndex, itemIndex, null, {}, { valueType: "checkItem", value: true });
}

export async function startNewActivity(tree, activity, initialItemId) {
	tree.set(PlayerPaths.SHOW_SPINNER, true);
	ambifi.persistenceManager.loadActivity(activity.id, initialItemId, true).then(async (loadedActivity) => {
		tree.set(PlayerPaths.SHOW_SPINNER, false);
		loadedActivity.showModeKey = `sm-${new Date().getTime()}`;
		// await initializeActivity(tree, _activity);
		// setSelectedItem(tree, 0, 0, 0, true, false);
		ensureExpanded(tree, 0, 0);
	}).catch((err) => {
		tree.set(PlayerPaths.SHOW_SPINNER, false);
		showError("Error", "Unable to reset activity.", err);
	});
}


export async function loadActivity(tree, activityId, initialItemId) {

	let activity = tree.get(PlayerPaths.ACTIVITY);
	let activityMetaData = getActivityMetaData(activity.id);

	tree.set(PlayerPaths.SHOW_SPINNER, true);

	if (activityMetaData.trackData !== false && tree.get(["storeCloudHistory"])) {
		ambifi.persistenceManager.save().then(() => {
			return ambifi.persistenceManager.loadActivity(activityId, initialItemId, true).then(async (activity) => {
				await resolveActivityFonts(activity);
				tree.set(PlayerPaths.SHOW_SPINNER, false);
				historyActions.openActivity(tree, tree.get(["user"]).identityId, activity);
			});
		}).catch((err) => {
			console.error(err);
			showError("Error", `Unable to load linked activity: ${activityId}.`, err);
		});
	} else {
		ambifi.persistenceManager.loadActivity(activityId, initialItemId, true).then(async (activity) => {
			await resolveActivityFonts(activity);
			tree.set(PlayerPaths.SHOW_SPINNER, false);
			historyActions.openActivity(tree, tree.get(["user"]).identityId, activity);
		}).catch((err) => {
			console.error(err);
			showError("Error", `Unable to load linked activity: ${activityId}.`, err);
		});
	}
}

export async function goBackFromLinkedActivity(tree, activity) {
	window.activityTheme = activity.theme;
	tree.set(PlayerPaths.ACTIVITY, activity);
	await resolveActivityFonts(activity);

	clearAppState(tree);

	initializeIdsAndVariableState(tree);
	initializeOrchestrator();

	//// console.log("CURRENT ACTIVITY: ", tree.get(PlayerPaths.ACTIVITY));
	//// console.log(JSON.stringify(tree.get(PlayerPaths.ACTIVITY), null, 4));



	Utils.populateIds(tree);
	Utils.buildGroups(tree);

	setDefaultValues(tree, 0, 0);
	setCompletionState(tree);
	refreshMandatory(tree);
	try {
		await actionsTimerManager.fetchMissingTimers(activity);
	} catch (e) {
		console.log(e);
	}
	historyActions.openActivity(tree, tree.get(["user"]).identityId, activity);
}

async function resolveResources(activity, propName) {
	if (activity && activity[propName] && _.isArray(activity[propName]) && !_.isEmpty(activity[propName])) {
		// Fetch them and add to _themes array
		let _contents = [];
		const n = activity[propName].length;
		for (let i = 0; i < n; i++) {
			// NEED TO TEST THIS! Caching is not disabled here!
			try {
				let content = activity[propName][i];
				if (_.isString(content) || isResourceReference(content)) {
					content = await getResourceContentForResourceRef(activity, content, false, false);
				}

				if (content && _.isPlainObject(content)) {
					_contents.push(content);
				}
			} catch (e) {
				console.warn("Unable to fetch content for resource", activity[propName][i], e);
			}
		}
		_contents.reverse(); // Reverse so the top one is the highest priority one ... otherwise confusing to the user when authoring
		console.log(`Got contents for resource ${propName}!`, _contents);
		activity[propName] = _contents;
	}
}

export async function initializeActivity(tree, activity, initialItem = null, skipToNextItem = false, root = true) {
	console.log("INITIALIZE ACTIVITY", activity);
	if (activity !== null) {
		if (activity.children &&
			activity.children.length > 0 &&
			activity.children[0].children &&
			activity.children[0].children.length > 0 &&
			activity.children[0].children[0].children &&
			activity.children[0].children[0].children.length > 0) {


			let clonedActivity = _.cloneDeep(activity);
			if (_.isUndefined(clonedActivity.instanceId)) {
				clonedActivity.instanceId = generateUUID();
			}
			let activities = state.get(PlayerPaths.ACTIVITIES);

			let inventoryEntry = _.find(activities, { id: clonedActivity.id });

			if (inventoryEntry) {
				console.log("Found inventory entry:", inventoryEntry);
				showReleaseNotes(inventoryEntry.id, inventoryEntry.publicationVersion, inventoryEntry.revision, inventoryEntry);
			}

			tree.set(PlayerPaths.ACTIVITY, clonedActivity);

			let selectedListIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);
			let selectedSectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
			let selectedItemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

			if (!_.isNumber(selectedListIndex)) {
				tree.set(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX, 0);
			}

			if (!_.isNumber(selectedSectionIndex)) {
				tree.set(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX, 0);
			}

			if (!_.isNumber(selectedItemIndex)) {
				tree.set(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX, 0);
			}

			tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, activity.id);


			const _activity = transformToActivityPlayer(tree.get(PlayerPaths.ACTIVITY));
			const nightMode = tree.get(["nightMode"]);
			let _themes = [themes[(nightMode) ? "nightMode" : "default"]];
			const orgPreferences = state.get(["orgPreferences"]);
			console.log("Org Preferences", orgPreferences);
			if (orgPreferences && orgPreferences.theme && _.isPlainObject(orgPreferences.theme) && (!activity.hasOwnProperty("noGlobalTheme") || !activity.noGlobalTheme)) { // eslint-disable-line
				_themes.push(orgPreferences.theme);
			}

			// See if there are any inline themes references
			if (activity.themes && _.isArray(activity.themes) && !_.isEmpty(activity.themes)) {

				tree.set(PlayerPaths.SHOW_SPINNER, true);
				console.log("Resolve activity themes", _activity.themes);
				await resolveResources(_activity, "themes");
				console.log("Resolved activity themes", _activity.themes);
				_themes = _.concat(_themes, _activity.themes);
			}

			if (_activity.theme && !_.isEmpty(_activity.theme)) {
				_themes.push(_activity.theme);
			}
			// console.log("Merged theme", theme);
			const theme = deepmerge.all(_themes);
			_activity.theme = theme;
			window.activityTheme = theme;

			let _stylesheets = [];
			if (orgPreferences && orgPreferences.stylesheet && _.isPlainObject(orgPreferences.stylesheet) && (!activity.hasOwnProperty("noGlobalStylesheet") || !activity.noGlobalStylesheet)) {
				_stylesheets.push(orgPreferences.stylesheet);
			}

			if (activity.stylesheets && _.isArray(activity.stylesheets) && !_.isEmpty(activity.stylesheets)) {
				await resolveResources(_activity, "stylesheets");
				_stylesheets = _.concat(_stylesheets, _activity.stylesheets);
			}

			if (activity.stylesheet && !_.isEmpty(activity.stylesheet)) {
				_stylesheets.push(activity.stylesheet);
			}

			_activity.stylesheet = deepmerge.all(_stylesheets);
			console.log("Resolved stylesheet", _activity.stylesheet);
			let _fonts = _activity.fonts;
			if (orgPreferences && orgPreferences.fonts) {
				_fonts = `${_fonts}\n${orgPreferences.fonts}`;
			}
			_activity.fonts = _fonts;

			Utils.resolveHierarchicalProperties(_activity, theme, nightMode);

			// Added this because Preview was crashing sporadically
			try {
				await actionsTimerManager.fetchMissingTimers(_activity);
			} catch (e) {
				console.log(e);
			}

			tree.set(PlayerPaths.ACTIVITY, _activity);

			/*
					if (activity.hasOwnProperty("global")) {
						global.ambifi = activity.global;
					}
					*/

			clearAppState(tree);

			initializeIdsAndVariableState(tree);
			initializeOrchestrator();

			//// console.log("CURRENT ACTIVITY: ", tree.get(PlayerPaths.ACTIVITY));
			//// console.log(JSON.stringify(tree.get(PlayerPaths.ACTIVITY), null, 4));



			Utils.populateIds(tree);
			Utils.buildGroups(tree);

			setDefaultValues(tree, 0, 0);
			setCompletionState(tree);
			refreshMandatory(tree);


			tree.set(PlayerPaths.SHOW_SPINNER, false);


			// If don't have any history, create it
			const history = tree.get(PlayerPaths.ACTIVITY_HISTORY);
			const historyGeoLocation = tree.get(PlayerPaths.ACTIVITY_HISTORY_GEOLOCATION);
			if (!history || !_.isArray(history)) {
				tree.set(PlayerPaths.ACTIVITY_HISTORY, []);
			}

			if (!historyGeoLocation || !_.isArray(historyGeoLocation)) {
				tree.set(PlayerPaths.ACTIVITY_HISTORY_GEOLOCATION, []);
			}

			if (!tree.get(PlayerPaths.ACTIVITY_LOGBOOK)) {
				tree.set(PlayerPaths.ACTIVITY_LOGBOOK_TIME_OUT, "------------");
				tree.set(PlayerPaths.ACTIVITY_LOGBOOK_TIME_OUT, "------------");
			}

			// Set instance id to latest instance
			//tree.set(["activity", "instanceId"], instanceId);

			//historyActions.openActivity(tree, tree.get(["user"]).identityId);

			//let activity = tree.get(PlayerPaths.ACTIVITY);
			//let firstLevel = tree.get(["activity", "firstLevel"]);


			// If a deep link is provided, go there
			// console.log("INITIALIZE ACTIVITY");
			if (root) {
				try {
					if (initialItem !== null) {
						let newItem = {
							listIndex: 0,
							sectionIndex: 0,
							itemIndex: 0
						};

						// console.log("INITIAL ITEM", initialItem);

						if (initialItem.startsWith("#")) {
							newItem = tree.get(["idMap", initialItem.substring(1)]);
						} else {
							let itemParts = initialItem.split(",");

							if (itemParts.length === 3) {
								newItem.listIndex = Number(itemParts[0]);
								newItem.sectionIndex = Number(itemParts[1]);
								newItem.itemIndex = Number(itemParts[2]);
							} else if (itemParts.length === 2) {
								newItem.listIndex = Number(itemParts[0]);
								newItem.sectionIndex = Number(itemParts[1]);
							} else if (itemParts.length === 1) {
								newItem.listIndex = Number(itemParts[0]);
							}
						}
						// Seems like hack
						//clearActivity(tree);
						gotoItemAndSpeak(tree, newItem.listIndex, newItem.sectionIndex, newItem.itemIndex);
					} else {
						// Seems like hack
						//clearActivity(tree);
						if (!skipToNextItem) {
							setTimeout(() => {
								showSelectedItem(tree);
							});
						} else {
							gotoItemAndSpeak(tree);
						}
					}
				} catch (e) {
					// Seems like hack
					gotoItemAndSpeak(tree, 0, 0, 0);
					//if (hideShowModeAfterSet) {
					//		tree.set(["appState", "modalShowModeVisible"], false);
					//	}						
				}

			}


			if (tree.get(PlayerPaths.ACTIVITY_START_IN_SHOW_MODE) && tree.get(["appCapabilities", "showMode"])) {
				//do something if show mode enabled
			} else {
				//do something else if show mode is not enabled
			}
		} else {
			throw new Error(tree.get(["content"]).alerts.activityNoContent);
		}
	}
}


export function setDefaultValues(tree, listIndex, sectionIndex, force = false) {

	let lists = tree.get(PlayerPaths.ACTIVITY_LISTS);

	setDefaultValuesRecurse(lists, tree, listIndex, sectionIndex, force);
}

export function setDefaultValuesForList(tree, listIndex, sectionIndex, force = false) {

	let sections = tree.get(PlayerPaths.ACTIVITY_SECTIONS(listIndex));

	setDefaultValuesRecurse(sections, tree, listIndex, sectionIndex, force);
}

export function setDefaultValuesForSection(tree, listIndex, sectionIndex, force = false) {

	let items = tree.get(PlayerPaths.ACTIVITY_ITEMS(listIndex, sectionIndex));

	setDefaultValuesRecurse(items, tree, listIndex, sectionIndex, force);
}


function setDefaultValuesRecurse(arr, tree, listIndex, sectionIndex, force) {

	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			listIndex = i;
		} else if (arr[i].type === "section") {
			sectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			let item = arr[i];
			let value;
			switch (item.type) {
				case "item":
					break;
				case "itemDate":
					if (!item.hasOwnProperty("value") || force) {
						if (item.hasOwnProperty("dateTimeInitialDate") && item.dateTimeInitialDate.toLowerCase() === "today") {
							value = "today";
						} else {
							value = item.dateTimeInitialDate;
						}
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemTime":
					if (!item.hasOwnProperty("value") || force) {
						if (item.hasOwnProperty("dateTimeInitialDate") && item.dateTimeInitialDate.toLowerCase() === "today") {
							value = "today";
						} else {
							value = item.dateTimeInitialDate;
						}
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemDateTime":
					if (!item.hasOwnProperty("value") || force) {
						if (item.hasOwnProperty("dateTimeInitialDate") && item.dateTimeInitialDate.toLowerCase() === "today") {
							value = "today";
						} else {
							value = item.dateTimeInitialDate;
						}
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemLocation":
					if (!item.hasOwnProperty("value") || force) {
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), { address: "(No location selected)", name: "No name selected" });
					}
					break;
				case "itemAddress":
					if (!item.hasOwnProperty("value") || force) {
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), { address: "(No location selected)", name: "No name selected" });
					}
					break;
				case "itemTextInput":
				case "itemTextInputMultiline":
					// Set default value
					if (!item.hasOwnProperty("value") || force) {
						if (item.hasOwnProperty("textInputDefaultValue") && item.textInputDefaultValue !== "") {
							tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), item.textInputDefaultValue);
						} else {
							tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), "");
						}
					}
					break;
				case "itemYesNo":
					if (!item.hasOwnProperty("value") || force) {
						let value = "";

						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemPicker":
					if (!item.hasOwnProperty("value") || force) {
						let value = "";
						if (item.hasOwnProperty("pickerItemDefaultValue") && item.pickerItemDefaultValue !== "") {
							value = item.pickerItemDefaultValue;
						}

						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemChoiceSingle":
					if (!item.hasOwnProperty("value") || force) {
						let value = "";

						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemChoiceMulti":
					if (!item.hasOwnProperty("value") || force) {
						let value = [];

						// for (var j = 0; j < item.choiceItems.length; j++) {
						// 	value.push(false);
						// }

						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), value);
					}
					break;
				case "itemImagePicker":
					if (!item.hasOwnProperty("value") || force) {
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "value"), null);
					}
					if (!item.hasOwnProperty("valueUrls") || force) {
						tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, i, "valueUrls"), null);
					}
					break;
				// case "itemBarcodeScanner":
				// 	if (!item.hasOwnProperty("barcode")) {
				// 		tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", i, "barcode"], null);
				// 	}	
				// case "itemSketchPad":
				// 	if (!item.hasOwnProperty("sketchPadImage")) {
				// 		tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", i, "sketchPadImage"], null);
				// 	}
				// 	if (!item.hasOwnProperty("sketchPadImagePaths")) {
				// 		tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", i, "sketchPadImagePaths"], []);
				// 	}	
				default:
					break;
			}
		}


		if (arr[i].hasOwnProperty("children")) {
			setDefaultValuesRecurse(arr[i].children, tree, listIndex, sectionIndex, force);
		}
	}
}

export async function saveActivity(tree = state) {

	// let activity = transformFromActivityPlayer(tree.get(PlayerPaths.ACTIVITY));

	// if (activity.history.length > 0) {
	// 	tree.set(PlayerPaths.SHOW_SPINNER, true);

	// 	return mobileAppCommunicationActions.saveHistoryInstances([activity]).then(() => {
	// 		tree.set(PlayerPaths.SHOW_SPINNER, false);
	// 	}).catch((err) => {
	// 		tree.set(PlayerPaths.SHOW_SPINNER, false);
	// 		showError("Activity Save Failed", "An error occurred saving the activity: " + err);
	// 	});
	// } else {
	// 	return Promise.resolve();
	// }	
	let activity = tree.get(PlayerPaths.ACTIVITY);
	let activityMetaData = getActivityMetaData(activity.id);

	if (activityMetaData.trackData !== false && tree.get(["storeCloudHistory"])) {
		state.set(PlayerPaths.SHOW_SPINNER, true);
		ambifi.persistenceManager.save().then(() => {
			state.set(PlayerPaths.SHOW_SPINNER, false);
		}).catch((err) => {
			state.set(PlayerPaths.SHOW_SPINNER, false);
			showError("Error", "Unable to save activity: " + err);
		});
	}
}

export function saveActivityAndExit(tree, submit = false) {
	//let before nav handle save
	// navActions.navigateTo("home");
	// console.log("SAVE AND EXIT", tree, submit);
	let activity = state.get(PlayerPaths.ACTIVITY);
	let activityMetaData = getActivityMetaData(activity.id);

	if (activityMetaData.trackData !== false && state.get(["storeCloudHistory"])) {
		state.set(PlayerPaths.SHOW_SPINNER, true);
		ambifi.persistenceManager.saveAndExit(submit).then((exitEvent) => {
			state.set(PlayerPaths.SHOW_SPINNER, false);

			if (ambifi.playerCallbacks.onExit) {
				SyntheticVoiceApi.stop();
				ambifi.playerCallbacks.onExit(exitEvent);
			}
			exitCleanup();
		}).catch((err) => {
			state.set(PlayerPaths.SHOW_SPINNER, false);
			showError("Error", "Unable to save activity: " + err);
		});
	} else {
		if (ambifi.playerCallbacks.onExit) {
			SyntheticVoiceApi.stop();
			ambifi.playerCallbacks.onExit({
				activity
			});
			exitCleanup();
		}
	}
}


export function saveActivityAndExitShowMode(tree) {
	//let before nav handle save
	let navStack = tree.get(PlayerPaths.NAV_STACK);

	// console.log("NAV STACK", navStack);

	if (navStack.length > 0) {
		let activity = tree.get(PlayerPaths.ACTIVITY);

		state.set(PlayerPaths.SHOW_SPINNER, true);

		let activityMetaData = getActivityMetaData(activity.id);
		const persistenceType = tree.get(["appState", "targetConfig", "type"]);
		const isNonDefaultPersistence = persistenceType && persistenceType.toLowerCase() !== "default";
		if (activityMetaData.trackData !== false && isNonDefaultPersistence && tree.get(["storeCloudHistory"])) {
			ambifi.persistenceManager.save().then(() => {
				state.set(PlayerPaths.SHOW_SPINNER, false);
				goBackFromLink(tree);
			}).catch((err) => {
				state.set(PlayerPaths.SHOW_SPINNER, false);
				showError("Error", "Unable to save activity: " + err);
			});
		} else {
			state.set(PlayerPaths.SHOW_SPINNER, false);
			goBackFromLink(tree);
		}
	} else {
		// navActions.navigateTo("home");
		saveActivityAndExit();
	}
}

export function exit() {
	let activity = state.get(PlayerPaths.ACTIVITY);
	if (ambifi.playerCallbacks.onExit) {
		ambifi.playerCallbacks.onExit({
			activity
		});
	}
	exitCleanup();
}


export function exitCleanup() {
	state.set(["loaded"], false);
	state.set(["timersList"], []);
	state.set(["timers"], {});
	state.set(["timerTemplates"], []);
	state.set(["appState", "itemModal"], {});
	state.set(["dimensions", "listLargestColumnWidth"], state.get(["dimensions", "defaultListLargestColumnWidth"]));
}

export function showSessionsModal(tree, activityId) {

	tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, activityId);

	sortSessions(tree, "updatedDateTimeDate");

	tree.set(PlayerPaths.SHOW_SESSIONS_MODAL, true);
}

export function closeSessionsModal(tree) {
	tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, "");
	tree.set(PlayerPaths.SHOW_SESSIONS_MODAL, false);
}

export function getSelectedActivityId() {
	return state.get(PlayerPaths.SELECTED_ACTIVITY_ID);
}

export function sortSessions(tree, sortCriteria) {
	// console.log("handle sort " + sortCriteria);

	let allActivitySessions = tree.get(PlayerPaths.SESSIONS);
	let selectedActivityId = tree.get(PlayerPaths.SELECTED_ACTIVITY_ID);

	if (!_.isUndefined(allActivitySessions[selectedActivityId])) {
		const now = moment();

		let sessions = allActivitySessions[selectedActivityId];
		let instanceDefinitions = sessions.map(function (instance, j) {
			const instanceDefiniton = _.cloneDeep(instance);
			instanceDefiniton.index = j;
			instanceDefiniton.today = false;
			const rawCreatedDate = instance.hasOwnProperty("createdDateTime") ? moment.utc(instance.createdDateTime * 1000).local() : null;
			let createdDateTime = null;
			if (rawCreatedDate) {
				createdDateTime = rawCreatedDate.local().format("MMMM Do YYYY, h: mm: ss a");
				instanceDefiniton.rawCreatedDate = rawCreatedDate;
				instanceDefiniton.createdDateTimeDate = rawCreatedDate.toDate();
			}
			instanceDefiniton.createdDateTimeFormatted = createdDateTime;
			const rawUpdatedDate = instance.hasOwnProperty("lastUpdatedDateTime") ? moment.utc(instance.lastUpdatedDateTime * 1000).local() : null;
			let updatedDateTime = null;
			if (rawUpdatedDate) {
				updatedDateTime = rawUpdatedDate.local().format("MMMM Do YYYY, h: mm: ss a");
				instanceDefiniton.today = now.isSame(rawUpdatedDate, "day");
				instanceDefiniton.updatedDateTimeDate = rawUpdatedDate.toDate();
			}
			instanceDefiniton.updatedDateTimeFormatted = updatedDateTime;
			return instanceDefiniton;
		});

		let sortedInstanceDefinitions = [];
		instanceDefinitions.forEach(instanceDefinition => {
			if (instanceDefinition.hasOwnProperty(sortCriteria) && instanceDefinition[sortCriteria] !== null) {
				sortedInstanceDefinitions.push(instanceDefinition);
			}
		});

		sortedInstanceDefinitions = _.reverse(_.sortBy(sortedInstanceDefinitions, [sortCriteria]));
		//// console.log("SORTED", sortCriteria, sortedInstanceDefinitions);

		_.reverse(instanceDefinitions).forEach(instanceDefinition => {
			if (!instanceDefinition.hasOwnProperty(sortCriteria) || instanceDefinition[sortCriteria] === null) {
				sortedInstanceDefinitions.push(instanceDefinition);
			}
		});

		tree.set(PlayerPaths.SORTED_SESSIONS, sortedInstanceDefinitions);
	} else {
		tree.set(PlayerPaths.SORTED_SESSIONS, []);
	}
}

export function itemSelected(tree, listIndex, sectionIndex, itemIndex) {
	let selectedListIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);
	let selectedSectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
	let selectedItemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);
	if (selectedListIndex === listIndex && selectedSectionIndex === sectionIndex && selectedItemIndex === itemIndex) {
		return true;
	} else {
		return false;
	}
}


export function setSelectedItemByGuid(tree, guid, autoScroll = false, speakSection = false, tries = 0) {
	console.log("Searching for ", guid);
	const result = Utils.findNodeByGuid(tree, guid);
	if (result) {
		console.log("Found ", guid, result);
		const { path } = result;
		const indices = [];
		path.forEach(pathPiece => {
			if (_.isNumber(pathPiece)) {
				indices.push(pathPiece);
			}
		});

		const props = ["listIndex", "sectionIndex", "itemIndex"];
		let itemPath = {
			listIndex: 0,
			sectionIndex: 0,
			itemIndex: 0
		};

		indices.forEach((index, idx) => {
			itemPath[props[idx]] = index;
		});
		// console.log("FOUND NODE", indices);
		const { listIndex, sectionIndex, itemIndex } = itemPath;
		setSelectedItem(tree, listIndex, sectionIndex, itemIndex, autoScroll, speakSection, tries);
	}
}


export function setSelectedItem(tree, listIndex, sectionIndex, itemIndex, autoScroll = false) {
	console.log("****** setSelectedItem");

	// Need to deal with visible
	let resultFindItemVisible = findItemVisible(tree, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: itemIndex });
	if (resultFindItemVisible !== null) {

		if (!listIndex && !sectionIndex) {
			setCompletionState(tree);
		}

		listIndex = resultFindItemVisible.listIndex;
		sectionIndex = resultFindItemVisible.sectionIndex;
		itemIndex = resultFindItemVisible.itemIndex;

		// console.log("In setSelectedItem: " + listIndex + "; " + sectionIndex + "; " + itemIndex + "; " + speakSection);

		const hasPrevious = listIndex > 0 || sectionIndex > 0 || itemIndex > 0; // Anything aside of the first item
		const lastItem = _.last(flattenedActivity).node;
		let hasNext = false;
		if (lastItem) {
			hasNext = listIndex !== lastItem.listIndex || sectionIndex !== lastItem.sectionIndex || itemIndex !== lastItem.itemIndex;
		}
		tree.set(PlayerPaths.ACTIVITY_PROPERTY("hasNext"), hasNext);
		tree.set(PlayerPaths.ACTIVITY_PROPERTY("hasPrevious"), hasPrevious);

		// Clear selected from whatever is currently selected
		let selectedListIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);
		let selectedSectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
		let selectedItemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "selected"), false);

		tree.set(PlayerPaths.ACTIVITY_PROPERTY("selectedListIndex"), listIndex);

		tree.set(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX, listIndex);
		tree.set(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX, sectionIndex);
		tree.set(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX, itemIndex);
		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "selected"), true);

		// let previousItem = tree.get(PlayerPaths.ACTIVITY_ITEM(selectedListIndex, selectedSectionIndex, selectedItemIndex));
		// let nextItem = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

		/*
		if (
			(previousItem.type.startsWith("itemTextInput") || previousItem.type.startsWith("itemBarcodeScanner"))
			&& global.inputs[selectedListIndex + "_" + selectedSectionIndex + "_" + selectedItemIndex]
			&& (!nextItem.type.startsWith("itemTextInput") && !nextItem.type.startsWith("itemBarcodeScanner"))) {
			setTimeout(function () {
				if (global.inputs[selectedListIndex + "_" + selectedSectionIndex + "_" + selectedItemIndex] !== null) {
					global.inputs[selectedListIndex + "_" + selectedSectionIndex + "_" + selectedItemIndex].blur();
				}
			}, 0);
		} else if (nextItem.type.startsWith("itemTextInput") || nextItem.type.startsWith("itemBarcodeScanner")) {
			// Try for 3 seconds
			if (tries === 30) {
				// console.log("*** EXHAUSETED NUMBER OF TRIES");
				return false;
			} else if (global.inputs[listIndex + "_" + sectionIndex + "_" + itemIndex] === null) {
				// console.log("*** TRY AGAIN " + tries);
				// Try again
				setTimeout(function () {
					setSelectedItem(tree, listIndex, sectionIndex, itemIndex, autoScroll, speakSection, tries++);
				}, 100);
			} else {
				if (!global.inputs[listIndex + "_" + sectionIndex + "_" + itemIndex].isFocused()) {
					setTimeout(function () {
						if (global.inputs[listIndex + "_" + sectionIndex + "_" + itemIndex] != null) {
							global.inputs[listIndex + "_" + sectionIndex + "_" + itemIndex].focus();
						}
					}, 0);
				}
			}
		}
		*/

		const defaultView = Utils.getListDefaultView(tree, listIndex);
		// const mode = tree.get("checklistView");

		if (defaultView !== "onePageView") {
			ensureExpanded(tree, listIndex, sectionIndex);
		}

		if (autoScroll) {
			setScrollToSelectedItem(tree, true);
		}

		return true;
	} else {
		return false;
	}
}

export function setNextSelected(tree, listIndex, sectionIndex) {
	// console.log("In setNextSelected: " + listIndex + "; " + sectionIndex + "; " + itemIndex);

	// If the current section is not complete then prompt
	//let currentList = tree.get(PlayerPaths.ACTIVITY_LIST(listIndex));
	let currentSection = tree.get(PlayerPaths.ACTIVITY_SECTION(listIndex, sectionIndex));

	// let item;

	if (findNextItemNotChecked(tree)) {
		// TODO: Not ideal...really need to figure out recursion with good return values
		// console.log(" >>>> RESULT FIND ITEM", resultFindItem);
		if (typeof resultFindItem.listIndex !== "undefined" && typeof resultFindItem.sectionIndex !== "undefined" && typeof resultFindItem.itemIndex !== "undefined") {

			let moveForward = Utils.getMoveForward(tree);
			if (moveForward || (listIndex === resultFindItem.listIndex && sectionIndex === resultFindItem.sectionIndex) || getSectionCompletionState(tree, currentSection, true) === "c") {
				let resultListIndex = resultFindItem.listIndex;
				let resultSectionIndex = resultFindItem.sectionIndex;
				let resultItemIndex = resultFindItem.itemIndex;


				if (resultListIndex !== listIndex || resultSectionIndex !== sectionIndex) {
					setCompletionState(tree);
				}


				if (listIndex !== resultListIndex) {
					setSelectedListIndex(tree, resultFindItem.listIndex);
				}

				ensureExpanded(tree, resultListIndex, resultSectionIndex);
				setSelectedItemAndSpeak(tree, resultListIndex, resultSectionIndex, resultItemIndex, true);
			} else {
				showPromptModalMoveForward(tree);
			}
		}
	}
}

// Could refactor to use flattenActivity
// Should be able to combine this function and findItemVisible
let resultFindItem;
let firstFindItem;

// Find next item not checked and not a labelOnly
function findNextItemNotChecked(tree, nextItem = null) {
	let lists = tree.get(PlayerPaths.ACTIVITY_PROPERTY("children"));
	resultFindItem = {};
	firstFindItem = true;

	if (nextItem === null) {
		nextItem = getNextItem(tree);
	}

	if (nextItem !== null) {
		findNextItemNotCheckedRecurse(lists, tree, 0, 0, 0, nextItem.listIndex, nextItem.sectionIndex, nextItem.itemIndex);
		return true;
	} else {
		return false;

		/*
		var selectedListIndex = tree.get(["activity", "selectedListIndex"]);
		var selectedSectionIndex = tree.get(["activity", "selected", "sectionIndex"]);

		// Find any unchecked in current section
		if (!tree.get(["moveForward"]) && findNextItemNotChecked(tree, { listIndex: selectedListIndex, sectionIndex: selectedSectionIndex, itemIndex: 0 })) {
			var item = tree.get(["activity", "children", nextItem.listIndex, "children", nextItem.sectionIndex, "children", nextItem.itemIndex]);
			if (Utils.isVisible(item)) {
				if (typeof resultFindItem.listIndex !== 'undefined' && typeof resultFindItem.sectionIndex !== 'undefined' && typeof resultFindItem.itemIndex !== 'undefined') {
					// var listIndex = resultFindItem.listIndex;
					// var sectionIndex = resultFindItem.sectionIndex;
					// var itemIndex = resultFindItem.itemIndex;

					// setSelectedItem(tree, listIndex, sectionIndex, itemIndex, true);

					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		} else {
			//alert("You are at the end of the activity.");
			return false;
		}
		*/
	}
}

function findNextItemNotCheckedRecurse(arr, tree, listIndex, sectionIndex, itemIndex, baseListIndex, baseSectionIndex, baseItemIndex) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			listIndex = i;
		} else if (arr[i].type === "section") {
			sectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			let larger = false;
			if (listIndex > baseListIndex) {
				larger = true;
			} else if (listIndex === baseListIndex && sectionIndex > baseSectionIndex) {
				larger = true;
			} else if (listIndex === baseListIndex && sectionIndex === baseSectionIndex && i >= baseItemIndex) {
				larger = true;
			}

			//if (!arr[i].checked && !arr[i].labelOnly && !arr[i].skipped && larger) {
			if (!arr[i].checked && Utils.isVisible(arr[i]) && !arr[i].skipItem && larger) {
				if (firstFindItem) {
					resultFindItem = {
						listIndex: listIndex,
						sectionIndex: sectionIndex,
						itemIndex: i
					};
					firstFindItem = false;
				}
			}
		}

		if (arr[i].hasOwnProperty("children") && Utils.isVisible(arr[i])) {
			findNextItemNotCheckedRecurse(arr[i].children, tree, listIndex, sectionIndex, itemIndex, baseListIndex, baseSectionIndex, baseItemIndex);
		}
	}
}

let flattenedActivity;
export function flattenActivity(tree) {
	let lists = _.cloneDeep(tree.get(PlayerPaths.ACTIVITY_PROPERTY("children")));
	flattenedActivity = [];
	flattenActivityRecurse(lists, tree, 0, 0);
}

function flattenActivityRecurse(arr, tree, listIndex, sectionIndex) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			listIndex = i;
		} else if (arr[i].type === "section") {
			sectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			let item = arr[i];
			let list = tree.get(PlayerPaths.ACTIVITY_LIST(listIndex));
			let section = tree.get(PlayerPaths.ACTIVITY_SECTION(listIndex, sectionIndex));
			// let visible = true;
			if (!Utils.isVisible(list)) {
				item.visible = false;
			} else if (Utils.isVisible(list) && !Utils.isVisible(section)) {
				item.visible = false;
			}
			flattenedActivity.push(
				{
					item: arr[i],
					node: {
						listIndex: listIndex,
						sectionIndex: sectionIndex,
						itemIndex: i
					}
				});
		}

		if (arr[i].hasOwnProperty("children")) {
			flattenActivityRecurse(arr[i].children, tree, listIndex, sectionIndex);
		}
	}
}

export function getNextItem(tree = state, listIndex, sectionIndex, itemIndex) {
	listIndex = _.isNumber(listIndex) ? listIndex : tree.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);
	sectionIndex = _.isNumber(sectionIndex) ? sectionIndex : tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
	itemIndex = _.isNumber(itemIndex) ? itemIndex : tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

	return findItemVisible(tree, { listIndex, sectionIndex, itemIndex }, true);
}

export function getPreviousItem(tree = state, listIndex, sectionIndex, itemIndex) {
	listIndex = _.isNumber(listIndex) ? listIndex : tree.get(PlayerPaths.ACTIVITY_SELECTED_LIST_INDEX);
	sectionIndex = _.isNumber(sectionIndex) ? sectionIndex : tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
	itemIndex = _.isNumber(itemIndex) ? itemIndex : tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

	return findItemVisible(tree, { listIndex, sectionIndex, itemIndex }, true, true);
}

export function findItemVisible(tree, initialItem, startNext = false, backward = false) {
	// Right now flattening everytime finding new item
	// Need to think where can centralize. Will then need to keep in sync.
	flattenActivity(tree);
	let startIndex = null;

	if (backward) {
		for (let i = flattenedActivity.length - 1; i >= 0; i--) {
			let fi = flattenedActivity[i];
			if (fi.node.listIndex === initialItem.listIndex && fi.node.sectionIndex === initialItem.sectionIndex && fi.node.itemIndex === initialItem.itemIndex) {
				startIndex = i;
			}
		}

		startIndex = startNext ? backward ? (startIndex - 1) : (startIndex + 1) : startIndex;

		for (let j = startIndex; j >= 0; j--) {
			let fi = flattenedActivity[j];
			if (Utils.isVisible(fi.item)) {
				return fi.node;
			}
		}
	} else {
		for (let i = 0; i < flattenedActivity.length; i++) {
			let fi = flattenedActivity[i];
			if (fi.node.listIndex === initialItem.listIndex && fi.node.sectionIndex === initialItem.sectionIndex && fi.node.itemIndex === initialItem.itemIndex) {
				startIndex = i;
			}
		}

		startIndex = startNext ? (startIndex + 1) : startIndex;

		for (let j = startIndex; j < flattenedActivity.length; j++) {
			let fi = flattenedActivity[j];
			if (Utils.isVisible(fi.item)) {
				return fi.node;
			}
		}
	}


	return null;
}

export function setSelectedListIndex(tree, index) {
	let list = tree.get(PlayerPaths.ACTIVITY_LIST(index));
	if (index >= 0 && Utils.isVisible(list) && list.enabled) {
		// Need to centralize so only in one place
		tree.set(PlayerPaths.ACTIVITY_PROPERTY("selectedListIndex"), index);
		tree.set(["dimensions", "listLargestColumnWidth"], tree.get(["appPreferences", "defaultColumnWidth"]));
		//tree.set(["activity", "selected", "listIndex"], index);
		refreshMandatory(tree);

		let currentList = tree.get(PlayerPaths.ACTIVITY_LIST_PROPERTY(index, "children"));

		let found = { type: "none" };
		getNextItemInSectionRecurse(currentList, index, 0, found);

		// console.log("FOUND", found);

		if (found.type.startsWith("item")) {
			//let sectionCollapsed = tree.get(PlayerPaths.ACTIVITY_SECTION_PROPERTY(found.listIndex, found.sectionIndex, "collapsed"));

			//if (!sectionCollapsed) {
			setSelectedItem(tree, found.listIndex, found.sectionIndex, found.itemIndex, true);
			//}
		} else {
			setSelectedItem(tree, index, 0, 0, true);
		}

		processListPreferences(tree);
	} else {
		// setSpinnerVisible(tree, false);
	}
}

function getNextItemInSectionRecurse(arr, listIndex, sectionIndex, found) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "section" && Utils.isVisible(arr[i])) {
			sectionIndex = i;

			if (arr[i].hasOwnProperty("children")) {
				getNextItemInSectionRecurse(arr[i].children, listIndex, sectionIndex, found);
			}
		} else if (arr[i].type.startsWith("item")) {
			//if (found.type !== "item" && !arr[i].checked && !arr[i].labelOnly) {
			if (!found.type.startsWith("item") && Utils.isVisible(arr[i]) && !arr[i].checked && !arr[i].skipItem) {
				found.type = "item";
				found.listIndex = listIndex;
				found.sectionIndex = sectionIndex;
				found.itemIndex = i;
			}
		}
	}
}

export function resetItem(tree, listIndex, sectionIndex, itemIndex) {
	// console.log(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));
	let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

	switch (item.type) {
		case "itemImagePicker":
			tree.unset(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "value"));
			tree.unset(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "valueUrls"));
			break;
		case "itemSketchPad":
			tree.unset(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "sketchPadImage"));
			tree.unset(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "sketchPadImagePaths"));
			tree.unset(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "sketchPadDimensions"));
			break;
		case "itemPicker":
		case "itemChoiceSingle":
		case "itemChoiceMulti":
		case "itemYesNo":
		case "itemDate":
		case "itemTime":
		case "itemDateTime":
		case "itemLocation":
		case "itemAddress":
		case "itemTextInput":
		case "itemTextInputMultiline":
			tree.unset(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "value"));
			break;
		default:
			break;
	}

	if (item.hasOwnProperty("id") && item.id !== "") {
		setValueIfHasIdOrchestratedSync(item, "");
	}

	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "checked"), false);
	// Reset visible from template
	// The template has all of the inital content
	// May be a better reset where everything we do comes from template

	// let activityTemplateIndex = getActivityIndexFromId(tree, tree.get(["activity"]).id);
	// let activityTemplate = tree.get(["activitys", activityTemplateIndex]);

	let activityTemplate = tree.get(PlayerPaths.ACTIVITY);

	let newItem = activityTemplate.children[listIndex].children[sectionIndex].children[itemIndex];
	let visible = true;
	if (!Utils.isVisible(newItem)) {
		visible = false;
	}
	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "visible"), visible);
}

export function getActivityIndexFromId(tree, id) {
	// // console.log(" In " + arguments.callee.name);
	let activities = tree.get(["activities"]);

	for (let i = 0; i < activities.length; i++) {
		let activity = activities[i];

		if (activity.id === id) {
			return i;
		}
	}
	return -1;
}

export function ensureExpanded(tree, listIndex, sectionIndex) {
	if (!_.isUndefined(sectionIndex)) {
		tree.set(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "expanded"), true);
		tree.set(PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, sectionIndex, "expanded"), true);
	} else {
		tree.set(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "expanded"), true);
	}
}

export function toggleExpandNode(tree, listIndex, sectionIndex) {
	SyntheticVoiceApi.stop();

	const item = Utils.getCurrentItemLocation(tree);

	let itemIndex = 0;
	if (item.listIndex === listIndex && item.sectionIndex === sectionIndex) {
		itemIndex = item.itemIndex;
	}

	if (!_.isUndefined(sectionIndex)) {
		let expanded = tree.get(PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, sectionIndex, "expanded"));
		tree.set(PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, sectionIndex, "expanded"), !expanded);

		if (!expanded) {
			setSelectedItemAndSpeak(state, listIndex, sectionIndex, itemIndex, true);
		}
	} else {
		let expanded = tree.get(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "expanded"));
		tree.set(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "expanded"), !expanded);

		if (!expanded) {
			setSelectedItemAndSpeak(state, listIndex, sectionIndex, itemIndex, true);
		}
	}
}

export function expandAll(tree) {
	expandCollapseInternal(tree, true);
}

export function collapseAll(tree) {
	expandCollapseInternal(tree, false);
}

function expandCollapseInternal(tree, expanded) {
	let activity = tree.get(PlayerPaths.ACTIVITY);

	if (!_.isUndefined(activity.children)) {
		for (let i = 0; i < activity.children.length; i++) {
			let listItem = activity.children[i];
			if (listItem.type === "list") {
				tree.set(PlayerPaths.ACTIVITY_LIST_PROPERTY(i, "expanded"), expanded);
				if (!_.isUndefined(listItem.children)) {
					for (let j = 0; j < listItem.children.length; j++) {
						tree.set(PlayerPaths.ACTIVITY_SECTION_PROPERTY(i, j, "expanded"), expanded);
					}
				}
			}
		}
	}
}

export function listExpandAll(tree, listIndex) {
	listExpandCollapseInternal(tree, listIndex, true);
}

export function listCollapseAll(tree, listIndex) {
	listExpandCollapseInternal(tree, listIndex, false);
}

function listExpandCollapseInternal(tree, listIndex, expanded) {
	let list = tree.get(PlayerPaths.ACTIVITY_LIST(listIndex));

	tree.set(PlayerPaths.ACTIVITY_LIST_PROPERTY(listIndex, "expanded"), expanded);
	if (!_.isUndefined(list.children)) {
		for (let i = 0; i < list.children.length; i++) {
			let sectionItem = list.children[i];
			if (sectionItem.type === "section") {
				tree.set(PlayerPaths.ACTIVITY_SECTION_PROPERTY(listIndex, i, "expanded"), expanded);
			}
		}
	}
}

export function gotoItem(tree, listIndex, sectionIndex, itemIndex, selectList = false) {

	if (Utils.isValidItem(tree, listIndex, sectionIndex, itemIndex)) {
		// TODO: Need to test heaviliy by removing this!!!
		if (selectList) {
			setSelectedListIndex(tree, listIndex);
		}
		setSelectedItem(tree, listIndex, sectionIndex, itemIndex, true);
		ensureExpanded(tree, listIndex, sectionIndex);

		return true;
	} else {
		showError("Error", "Error trying to go to an invalid item.");
		return false;
	}
}

export function gotoNextItem(tree) {
	// // console.log(" In " + arguments.callee.name);
	let item = getNextItem(tree);

	if (item !== null) {
		gotoItem(tree, item.listIndex, item.sectionIndex, item.itemIndex);
	} else {
		SyntheticVoiceApi.stop();
		SyntheticVoiceApi.speak("You are on the last item.");
		//Alert.alert("", "You are on the last item.");
	}
}

export function gotoNextItemAndSpeak() {
	// console.log(" In " + arguments.callee.name);
	const tree = state;

	let item = getNextItem(tree);

	if (item !== null) {
		gotoItemAndSpeak(tree, item.listIndex, item.sectionIndex, item.itemIndex);
	} else {
		SyntheticVoiceApi.stop();
		SyntheticVoiceApi.speak("You are on the last item.");
		//Alert.alert("", "You are on the last item.");
	}
}

export function gotoPreviousItem(tree) {
	SyntheticVoiceApi.stop();

	// // console.log(" In " + arguments.callee.name);
	let item = getPreviousItem(tree);

	if (item !== null) {
		gotoItemAndSpeak(tree, item.listIndex, item.sectionIndex, item.itemIndex);
	} else {
		SyntheticVoiceApi.speak("You are on the first item.");
		//Alert.alert("", "You are on the first item.");
	}
}

export function showSelectedItem(tree = state) {
	// console.log("SHOW SELECTED ITEM");
	let listIndex = tree.get(["activity", "selected", "listIndex"]);
	let sectionIndex = tree.get(["activity", "selected", "sectionIndex"]);
	let itemIndex = tree.get(["activity", "selected", "itemIndex"]);

	setSelectedItemAndSpeak(tree, listIndex, sectionIndex, itemIndex, true, false);
}

export function clearCurrentActivityNoConfirm(tree, force = false) {
	let currentActivity = tree.get(["activity"]);
	if (currentActivity.hasOwnProperty("children") || (currentActivity && force)) {
		// alert("RESET");
		startNewActivity(tree, currentActivity);
	}
}

export function clearCurrentListNoConfirm(tree) {
	const listIndex = tree.get(["activity", "selectedListIndex"]);
	const list = tree.get(["activity", "children", listIndex]);

	let identityId = tree.get(["user"]).identityId;

	historyActions.clearList(tree, getActivityItemHistoryPath(listIndex, 0, 0), identityId, list);

	SyntheticVoiceApi.stop();
	SyntheticVoiceApi.speak(tree.get(["content"]).mira.speaks.resettingList + " " + getNameAudio(list));

	const listChildren = list.children;
	for (let i = 0; i < listChildren.length; i++) {
		const sectionChildren = listChildren[i].children;
		for (let j = 0; j < sectionChildren.length; j++) {
			resetItem(tree, listIndex, i, j);

			historyActions.uncheckItem(tree, getActivityItemHistoryPath(listIndex, 0, 0), identityId, tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, 0, 0)));

			setCompletionState(tree);
		}
	}

	setDefaultValuesForList(tree, listIndex, 0, true);

	//saveCurrentActivityToStore(tree);

	refreshMandatory(tree);

	//setTimeout(function() {
	setSelectedItem(tree, listIndex, 0, 0, true);
	//},0);
}

export function clearCurrentSectionNoConfirm(tree) {
	const listIndex = tree.get(["activity", "selected", "listIndex"]);
	const sectionIndex = tree.get(["activity", "selected", "sectionIndex"]);

	const section = tree.get(["activity", "children", listIndex, "children", sectionIndex]);

	let identityId = tree.get(["user"]).identityId;

	historyActions.clearSection(tree, getActivityItemHistoryPath(listIndex, sectionIndex, 0), identityId, section);
	SyntheticVoiceApi.stop();
	SyntheticVoiceApi.speak(tree.get(["content"]).mira.speaks.resettingSection + " " + getNameAudio(section));
	const sectionChildren = section.children;
	for (let i = 0; i < sectionChildren.length; i++) {
		resetItem(tree, listIndex, sectionIndex, i);

		historyActions.uncheckItem(tree, getActivityItemHistoryPath(listIndex, sectionIndex, 0), identityId, tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, 0)));

		setCompletionState(tree);
	}

	setDefaultValuesForSection(tree, listIndex, sectionIndex, true);

	//saveCurrentActivityToStore(tree);

	refreshMandatory(tree);

	//setTimeout(function() {
	setSelectedItem(tree, listIndex, sectionIndex, 0, true);
	//},0);
}

function clearItems(tree, startItemNode, endItemNode) {
	const lists = tree.get(["activity", "children"]);

	const startId = tree.get(["activity", "children", startItemNode.listIndex, "children", startItemNode.sectionIndex, "children", startItemNode.itemIndex, "guid"]);
	const endId = tree.get(["activity", "children", endItemNode.listIndex, "children", endItemNode.sectionIndex, "children", endItemNode.itemIndex, "guid"]);

	let identityId = tree.get(["user"]).identityId;

	historyActions.resetItemsInRange(tree, getActivityItemHistoryPath(endItemNode.listIndex, endItemNode.sectionIndex, endItemNode.itemIndex), identityId, tree.get(PlayerPaths.ACTIVITY));

	inClear = false;
	clearItemsRecurse(lists, tree, 0, 0, startId, endId);
}

let inClear;

function clearItemsRecurse(arr, tree, listIndex, sectionIndex, startId, endId) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			listIndex = i;
		} else if (arr[i].type === "section") {
			sectionIndex = i;
		} else if (arr[i].type.startsWith("item")) {
			if (arr[i].guid === startId) {
				inClear = true;
			}
			if (inClear) {
				resetItem(tree, listIndex, sectionIndex, i, true);
			}
			if (arr[i].guid === endId) {
				inClear = false;
			}

		}

		if (arr[i].hasOwnProperty("children")) {
			clearItemsRecurse(arr[i].children, tree, listIndex, sectionIndex, startId, endId);
		}
	}
}



export function linkUrl(tree, url, currentItem = Utils.getCurrentItemLocation(state), linkOnCheck = false, stopAudio = true) {
	if (stopAudio) {
		SyntheticVoiceApi.stop();
	}
	let currentActivityIndex = getActivityIndexFromId(tree, tree.get(["activity"]).id);
	//// console.log(" In " + arguments.callee.name);

	let activity = tree.get(PlayerPaths.ACTIVITY);

	let retVal = false;

	let pathParts;
	let isItemModal = false;
	if (url.toLowerCase().startsWith("resetcurrentactivity")) {
		clearCurrentActivityNoConfirm(tree);
		return;
	} else if (url.toLowerCase().startsWith("resetcurrentlist")) {
		clearCurrentListNoConfirm(tree);
		return;
	} else if (url.toLowerCase().startsWith("openitemmodal") || url.toLowerCase().startsWith("showmodalitem")) {
		isItemModal = true;
		const urlParts = url.split(":");
		let queryString = {};
		if (urlParts[1].indexOf("?") !== -1) {
			pathParts = urlParts[1].split("?");
			// console.log("PARSING", pathParts[1])
			queryString = qs.parse(pathParts[1]);
			// console.log("PARSING result", queryString);
		}

		if (!_.isPlainObject(queryString)) {
			queryString = {}; // Make sure it's always an object
		}

		console.log("SHOW MODAL URL", url);
		console.log("SHOW MODAL URL PARTS", urlParts);

		showItemModal(tree, queryString, urlParts[1]);
		return;
	} else if (url.toLowerCase().startsWith("resetcurrentsection")) {
		clearCurrentSectionNoConfirm(tree);
		return;
	} else if (url.toLowerCase().startsWith("saveactivityandexit")) {
		saveActivityAndExit();
		return;
	} else if (url.toLowerCase().startsWith("opencomments")) {
		showComments(tree, 0);
		return;
	} else if (url.toLowerCase().startsWith("opennotes")) {
		showComments(tree, 1);
		return;
	} else if (url.toLowerCase().startsWith("openmedia")) {
		alert("Media attachments not supported in web player yet.");
		// showComments(tree, 2);
		return;
	} else if (url.toLowerCase().startsWith("opensketchpad")) {
		// showComments(tree, 3);
		alert("Sktechpad not supported in web player yet.");
		return;
	} else if (url.toLowerCase().startsWith("goback")) {
		goBackFromLink(tree);
		return;
	}


	if (url.toLowerCase().startsWith("goto:") ||
		url.toLowerCase().startsWith("newsessionandgoto:") ||
		url.toLowerCase().startsWith("gotoandreturn:") ||
		url.toLowerCase().startsWith("newsessionandgotoandreturn:") ||
		url.toLowerCase().startsWith("resetrangeandgoto:") ||
		url.toLowerCase().startsWith("gotoandopenbirdseyeview:")) {

		let urlParts = url.split(":");

		// Test if have a activity to navigate to. If do, set the activityIndex.
		let pathParts = [urlParts[1]];
		// let queryString = {};
		if (urlParts[1].indexOf("?") !== -1) {
			pathParts = urlParts[1].split("?");
			// console.log("PARSING", pathParts[1]);
			// queryString = qs.parse(pathParts[1]);
			// console.log("PARSING result", queryString);
		}
		let path = pathParts[0];

		if (path === "") {
			setNextSelected(tree, currentItem.listIndex, currentItem.sectionIndex, currentItem.itemIndex);
			return;
		}

		pathParts = path.split(";");
		// let activityIndex = -1;
		let activityInternalId;

		let item;

		let hasActivity = false;
		let hasItem = false;
		// let _activity = null;
		let _origActivity = tree.get(["activity"]);

		// console.log(tree.get(["activities"]));
		let myActs = tree.get(["activities"]);

		if (pathParts.length > 1) {
			// Was causing very weird issue
			//let activities = tree.get(["activities"]);
			for (let i = 0; i < myActs.length; i++) {
				let myAct1 = myActs[i];
				if (myAct1.hasOwnProperty("checklistId") && myAct1.checklistId === pathParts[0]) {
					// Need to support deep linking to item
					// _activity = myAct1;
					// activityIndex = i;
					hasActivity = true;
					activityInternalId = myAct1.id;
				}
			}

			hasItem = true;
			item = pathParts[1];
		} else {
			// Don't have activity
			if (pathParts[0].startsWith("#")) {
				hasItem = true;
				item = pathParts[0];
			} else {
				// Was causing very weird issue
				//let activities = tree.get(["activities"]);
				for (let i = 0; i < myActs.length; i++) {
					let myAct2 = myActs[i];
					if (myAct2.hasOwnProperty("checklistId") && myAct2.checklistId === pathParts[0]) {
						// Need to support deep linking to item
						// _activity = myAct2;
						// activityIndex = i;
						hasActivity = true;
						activityInternalId = myAct2.id;
					}
				}
			}
		}

		// Do navigation
		if (hasActivity) {

			// let promise;

			// let reset = _activity ? _activity.startInShowMode : queryString.reset ? queryString.reset : false;
			// console.log("RESET?", queryString, reset, _activity);

			let newSession = false;
			if (url.toLowerCase().startsWith("newsessionandgoto:") || url.toLowerCase().startsWith("newsessionandgotoandreturn:")) {
				newSession = true;
			}

			if (hasItem) {
				loadActivity(tree, activityInternalId, item, newSession);
			} else {
				loadActivity(tree, activityInternalId, undefined, newSession);
			}
			tree.set(["associatedContentCard"], {
				show: false
			});
			// promise.catch((err) => {
			// 	showError("Error", "Unable to go to link: " + err);
			// });

			// Fix function to return true or false
			retVal = true;
			// If jump within activity  
		} else {
			if (!_.isUndefined(item) && item !== null) {
				if (item.startsWith("#")) {
					if (url.toLowerCase().startsWith("newsessionandgoto:") || url.toLowerCase().startsWith("newsessionandgotoandreturn:")) {
						clearCurrentActivityNoConfirm(tree);
					}

					let newItem = tree.get(["idMap", item.substring(1)]);

					if (newItem !== null) {
						if (url.toLowerCase().startsWith("gotoandopenbirdseyeview:")) {
							setSelectedListIndexAndSpeak(tree, newItem.listIndex, true);
							return;
						}

						if (url.toLowerCase().startsWith("resetrangeandgoto:")) {
							let startItemNode = newItem;
							let endItemNode = currentItem;
							clearItems(tree, startItemNode, endItemNode);
							setCompletionState(tree);
							refreshMandatory(tree);
						}

						//ensureExpanded(tree, newItem.listIndex, newItem.sectionIndex);
						retVal = gotoItemAndSpeak(
							tree,
							newItem.listIndex,
							newItem.sectionIndex,
							newItem.itemIndex
						);

						//var item = tree.get(["activity", "children", found.listIndex, "children", found.sectionIndex, "children", 0]);
						//let item = tree.get(["activity", "children", newItem.listIndex, "children", newItem.sectionIndex, "children", newItem.itemIndex]);

					} else {
						showError("Error", "The ID you are linking to could not be found.");
					}
				} else {
					showError("Error", "Invalid link.");
				}
			} else {
				showError("Error", "The ID you are linking to could not be found.");
			}
		}

		// Should I support two different stacks...one for activitys and one for items in activitys?
		if ((url.toLowerCase().startsWith("gotoandreturn:") || url.toLowerCase().startsWith("newsessionandgotoandreturn:")) && !!retVal) {


			const _currentItem = getSelectedItem(currentItem, _origActivity);
			// // console.log("Current selected", _currentItem, currentItem);
			const hierarchy = getSelectionHierarchy(currentItem, _origActivity);
			const navTitle = _currentItem && _currentItem.hasOwnProperty("navTitle") ? _currentItem.navTitle : null;
			let navEntry = {
				linkOnCheck,
				navTitle,
				item: currentItem
			};

			if (hierarchy && hierarchy.list && hierarchy.section && hierarchy.item) {

				const { list, section, item } = hierarchy;

				navEntry = _.assign({}, navEntry, {
					listName: list.navTitle ? list.navTitle : Utils.getRealName(list.name),
					sectionName: section.navTitle ? section.navTitle : Utils.getRealName(section.name),
					itemName: item.navTitle ? item.navTitle : removeMd(item.label1)
				});
			}

			if (hasActivity) {
				navEntry = _.assign({}, navEntry, { activityIndex: currentActivityIndex, activityInstanceId: _origActivity.id, activityName: _origActivity.name, activity: _.cloneDeep(activity), item: currentItem, linkOnCheck });
				tree.push(PlayerPaths.NAV_STACK, navEntry);
			} else {
				navEntry = _.assign({}, navEntry, { activityName: activity.name, item: currentItem, linkOnCheck });
				tree.push(PlayerPaths.NAV_STACK, navEntry);
			}
		}
	} else {
		Utils.openURL(url);
	}

	// If the link target doesn't show in the item modal then we want to hide it
	if (!isItemModal && itemModalVisible()) {
		hideItemModal();
	}
}

export function showComments(tree, idx, userNotesVisible, hasComments) {
	tree.set(["player", "showComments"], true);
	tree.set(["player", "showCommentsIdx"], idx ? idx : hasComments ? 0 : 1);
	tree.set(["player", "showCommentsUserNotesVisible"], userNotesVisible);
	tree.set(["player", "showCommentsHasComments"], hasComments);
}

export function hideComments(tree) {
	tree.set(["player", "showComments"], false);
	tree.set(["player", "showCommentsIdx"], 0);
	tree.set(["player", "showCommentsUserNotesVisible"], false);
	tree.set(["player", "showCommentsHasComments"], false);
}

export function selectCommentsTab(tree, idx) {
	tree.set(["player", "showCommentsIdx"], idx ? idx : 0);
}

// Support linking to items, sections and lists as well as typical default URL behaviors
export function goBackDismiss(tree) {
	tree.set(PlayerPaths.NAV_STACK, []);
}

export function goBackFromLink(tree) {
	let navStack = tree.get(PlayerPaths.NAV_STACK);

	if (navStack.length > 0) {
		let newItem = navStack.pop();

		// If a different activity
		if (newItem.hasOwnProperty("activity")) {
			// Need to support deep linking
			//setCurrentActivityFromStore(tree, newItem.activityIndex, null, false, null, newItem.linkOnCheck, hideShowMode);			
			goBackFromLinkedActivity(tree, newItem.activity);
		} else {
			gotoItem(
				tree,
				newItem.item.listIndex,
				newItem.item.sectionIndex,
				newItem.item.itemIndex
			);
		}

		tree.set(PlayerPaths.NAV_STACK, navStack);
	}
}

export function setNotes(tree, listIndex, sectionIndex, itemIndex, notes, saveHistory = true) {
	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(listIndex, sectionIndex, itemIndex, "notes"), notes);
	if (saveHistory) {
		let item = tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));
		let identityId = tree.get(["user"]).identityId;
		historyActions.setNotes(tree, listIndex + "," + sectionIndex + "," + itemIndex, notes, identityId, item);
	}
}

export function setSelectedHomeTab(tree, tab) {
	tree.set(PlayerPaths.SELECTED_HOME_TAB, tab);
}

export async function initWebPlayer(tree, params) {
	console.log("INIT WEB PLAYER", params);
	window.TtsEvents = new EventEmitter();

	SyntheticVoiceApi.clearSpeechCache();

	//delete config, override with params
	Utils.deleteAllObjectKeys(config);
	let _globalConfig = {};
	try {
		_globalConfig = globalConfig ? globalConfig : {};//eslint-disable-line
	} catch (e) {
		console.warn(e);
	}
	_.merge(config, params.config, _globalConfig);




	//delete env, override with params
	Utils.deleteAllObjectKeys(env);
	_.merge(env, params.env);

	let activities = params.activities;

	//set new state by merging current and passed in state
	const currentState = state.get();
	console.log("Current State", currentState);
	const userInfo = currentState.user;
	// const audio = _.get(currentState, "appPreferences.voice.audio", false);
	const paramsState = params.state.get();
	let newState = deepmerge(currentState, paramsState);
	// newState.audio = audio;
	if (params.activateVoice) {
		_.set(newState, "appPreferences.voice.audio", true);
	}
	if (paramsState.user && paramsState.user.identityId === "test-identity-id") {
		_.set(newState, "user", userInfo); // Can't hurt to set it to what it was before, if an identityId is provided then honor that
	}
	console.log("Setting state", newState);
	state.set(newState);
	state.set(["orgPreferences"], {});
	state.set(["timersList"], []);
	state.set(["timers"], {});
	state.set(["env"], env);
	try {
		if (!_.isUndefined(orgPreferences) && _.isPlainObject(orgPreferences)) { // eslint-disable-line
			state.set(["orgPreferences"], orgPreferences);// eslint-disable-line
		}
	} catch (e) {
		console.warn(e);
	}

	if (params.orgPreferences) {
		const { theme, "tts-phonetics": phonetics, stylesheet, fonts } = params.orgPreferences;
		if (theme && _.isPlainObject(theme)) {
			state.set(["orgPreferences", "theme"], theme);// eslint-disable-line
		}

		if (stylesheet && _.isPlainObject(stylesheet)) {
			state.set(["orgPreferences", "stylesheet"], stylesheet);// eslint-disable-line
		}

		if (fonts && _.isString(fonts) && !_.isEmpty(fonts)) {
			state.set(["orgPreferences", "fonts"], fonts);// eslint-disable-line
		}

		if (phonetics && _.isPlainObject(phonetics)) {
			state.set(["orgPreferences", "tts-phonetics"], phonetics);// eslint-disable-line
		}

		if (fonts && _.isString(fonts) && !_.isEmpty(fonts)) {
			state.set(["orgPreferences", "fonts"], fonts);// eslint-disable-line
		}

		if (stylesheet && _.isPlainObject(stylesheet)) {
			state.set(["orgPreferences", "stylesheet"], stylesheet);// eslint-disable-line
		}
	}

	try {
		if (!_.isUndefined(timerTemplates) && _.isArray(timerTemplates)) { // eslint-disable-line
			state.set(["timerTemplates"], timerTemplates);// eslint-disable-line
		}
	} catch (e) {
		console.warn(e);
	}

	if (params.timerTemplates && _.isArray(params.timerTemplates)) {
		state.set(["timerTemplates"], params.timerTemplates);// eslint-disable-line
	}



	console.log("WEB PLAYER INITIALIZE", params, state.get());
	// Initialize the drive tree
	if (params.hasOwnProperty("drive") && params.drive) {
		initializeDrive(params.drive);
	}

	Utils.deleteAllObjectKeys(ambifi);
	ambifi.playerCallbacks = {};
	ambifi.playerCallbacks = params.playerCallbacks;

	//Initialize persistence
	let targetConfig = config.persistence;
	console.log("Get persistence manager for config", targetConfig);
	ambifi.persistenceManager = PersistenceManagerFactory.buildFromConfig(targetConfig);

	state.set(["appState", "targetConfig"], targetConfig);

	if (params.hasOwnProperty("inlineShowMode")) {
		state.set(["appState", "inlineShowMode"], params.inlineShowMode);
	}

	//clear theme cache when creating new instance of player
	Utils.clearThemeCache();

	try {
		console.log("About to init activities", activities, params);
		await ambifi.persistenceManager.init({
			activities,
			activityId: params.activityId,
			activityInstanceId: params.activityInstanceId,
			activityIdentityId: params.activityIdentityId
		});
		console.log("Done initializing");
		let activity = state.get(PlayerPaths.ACTIVITY);

		if (!_.isEmpty(activity) && !_.isUndefined(activity)) {
			// This should be the first action
			// SyntheticVoiceApi.stop();
			SyntheticVoiceApi.stop();
			const nameAudio = getNameAudio(tree.get(["activity"]));
			if (nameAudio && nameAudio.trim && nameAudio.trim().length > 0) {
				SyntheticVoiceApi.speak(tree.get(["content"]).mira.speaks.checklist + " " + nameAudio);
			}
			// SyntheticVoiceApi.speakActivity(activity, { prop: ["name"] });

			await resolveActivityFonts(activity);

			historyActions.openActivity(state, state.get(["user"]).identityId, state.get(PlayerPaths.ACTIVITY));

			await ambifi.persistenceManager.setCompletionState("incomplete");

			injectCustomStyling();

			//if expand all do it here
			if (state.get(["_config", "expandAllOnLoad"]) === true) {
				expandAll(state);
			}



			/*
			const nameAudio = getNameAudio(tree.get(["activity"]));

			if (nameAudio && nameAudio.trim && nameAudio.trim().length > 0) {
				SyntheticVoiceApi.speak(tree.get(["content"]).mira.speaks.checklist + " " + nameAudio);
			}
			*/


			if (params.playerCallbacks.onLoad) {
				params.playerCallbacks.onLoad();
			}
		} else {
			if (params.playerCallbacks.onLoadError) {
				params.playerCallbacks.onLoadError(new Error(`Unable to load activity: ${params.activityId}, instanceId: ${params.activityInstanceId}`));
			}
		}

		state.set(["loaded"], true);
	} catch (err) {
		console.error("Failed to launch web player", err);
		if (params.playerCallbacks.onLoadError) {
			params.playerCallbacks.onLoadError(err);
		}
	}
}

/**
 * Loads activity from activities collection when all activities are loaded at once
 * as a published array of JSON objects
 * 
 * @param {*} activityId 
 * @param {*} initialItemId 
 */
export async function loadPublishedActivity(activityId, initialItemId) {
	let activities = state.get(PlayerPaths.ACTIVITIES);

	let activity = _.find(activities, { id: activityId });

	//put current activity back into array
	let currentActivity = state.get(PlayerPaths.ACTIVITY);
	let currentActivityIdx = _.findIndex(activities, { id: currentActivity.id });

	state.set(["activities", currentActivityIdx], currentActivity);

	await initializeActivity(state, activity, initialItemId);

	return activity;
}

/*
export function handleChangeProperty(tree, listIndex, sectionIndex, itemIndex, name, value) {
	if (name !== "value") {
		handleChangePropertyDisconnected(tree, listIndex, sectionIndex, itemIndex, name, value);
	} else {
		let item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
		// console.log("IFTTT VARIABLE VALUE SET REQUEST - handleChangeProperty");
		setValueIfHasIdOrchestratedSync(item, value).then(() => {


			tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex, name], value);
			saveLastItemValue(tree, value);
			tree.commit();

			// Moved this down as it might be looking at the node value
			if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
				// Inject global procedure functions
				let strfun = tree.get(["activity", "functions"]);
				if (strfun !== "") {
					eval(strfun);
				}
				let AmbiFi = RuntimeApi;
				eval(item.valueTrigger);
				//tree.set(["session"], tree.get(["session"]) + 1);
			}
		});
	}
}

export function handleChangeBarcodeProperty(tree, listIndex, sectionIndex, itemIndex, value) {
	let item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
	tree.set(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex, "barcode", "data"], value);

	tree.commit();
}
*/

export function hideAssociatedContentCard() {
	state.set(["associatedContentCard"], { show: false });
}

export function showAssociatedContentCard(item, template, targetStyles, targetTextStyles, listIndex, sectionIndex, itemIndex) {
	try {
		const _template = Handlebars.compile(template, { noEscape: true });
		const renderedAssociatedContent = _template({ data: item.associatedContent });

		state.set(["associatedContentCard"], {
			show: true,
			stage: 0,
			associatedContent: item.associatedContent,
			template,
			renderedAssociatedContent,
			targetStyles,
			label: item.label,
			targetTextStyles,
			listIndex,
			sectionIndex,
			itemIndex
			// overrideRules
		});
	} catch (e) {
		console.error(e);
		// Alert.alert(
		// 	'Render Associated Content',
		// 	'An error occurred while attempting to render the associated content.');
	}

}

export function increaseStage() {
	state.set(["associatedContentCard", "stage"], state.get(["associatedContentCard", "stage"]) + 1);
}

export async function resolveActivityFonts(activity) {
	console.log("Resolve activity fonts", activity.fonts);
	const orgPreferences = state.get(["orgPreferences"]);
	if ((activity && activity.fonts) || orgPreferences.fonts) {
		//clear out previous activity linksP
		let head = document.getElementsByTagName("head")[0];
		let elementsToRemove = [];
		let ambifiFontRefs = [];

		for (let i = 0; i < head.childNodes.length; i++) {
			let node = head.childNodes[i];
			if (node.nodeName.toLowerCase() === "link" && node.getAttribute("data-activity-fonts-css") === "true") {
				elementsToRemove.push(node);
			} else if (node.nodeName.toLowerCase() === "style" && node.getAttribute("id") === "ambifi-fonts-style") {
				elementsToRemove.push(node);
			}

		}

		for (let i = 0; i < elementsToRemove.length; i++) {
			head.removeChild(elementsToRemove[i]);
		}

		//create DOM and append links to head
		let el = document.createElement("head");

		let fonts = "";
		if (activity.fonts) {
			fonts += activity.fonts;
		}

		if (orgPreferences.fonts) {
			fonts += orgPreferences.fonts;
		}

		el.innerHTML = "<head>" + fonts + "</head>";

		let links = el.childNodes;

		for (let i = 0; i < links.length; i++) {
			//need to clone because this link has different parent than actual head element
			let link = links[i];
			if (link.nodeName.toLowerCase() === "link") {
				let newLink = document.createElement("link");
				newLink.setAttribute("href", link.getAttribute("href"));
				newLink.setAttribute("rel", link.getAttribute("rel"));
				newLink.setAttribute("data-activity-fonts-css", true);
				head.appendChild(newLink);
			} else if (link.nodeName.toLowerCase() === "font") {

				if (link.getAttribute("type") === "ambifi") {
					let ref = link.getAttribute("ref");
					if (ambifiFontRefs.indexOf(ref) === -1) {
						ambifiFontRefs.push(ref);
					}
				}
			}
		}
		// For some reason when this awaits generateAmbifiFontCss we have an issue with TTS
		// in that the player skips the first item since the requests

		const ambifiFontCss = await generateAmbifiFontCss(ambifiFontRefs);
		let ambifiFontStyleEl = document.createElement("style");
		ambifiFontStyleEl.setAttribute("id", "ambifi-fonts-style");
		ambifiFontStyleEl.setAttribute("type", "text/css");
		ambifiFontStyleEl.innerHTML = ambifiFontCss;

		head.appendChild(ambifiFontStyleEl);
	}
}

export function setExpandedBreadcrumbView(tree, expandedView, searchFocus = false) {
	tree.set(["player", "breadcrumb", "expandedView"], expandedView);
	tree.set(["player", "breadcrumb", "searchFocus"], searchFocus);
}

export function getSelectionHierarchy(currentItem = state.get(["activity", "selected"]), activity = null) {

	let result = {
		list: null,
		section: null,
		item: null
	};
	try {
		if (currentItem) {
			const { listIndex, sectionIndex, itemIndex } = currentItem;
			const list = activity ? _.get(activity, `children.${listIndex}`, null) : state.get(["activity", "children", listIndex]);
			if (!list) {
				return result;
			}
			result.list = list;

			const section = _.get(list, `children.${sectionIndex}`, null);
			if (!section) {
				return result;
			}

			result.section = section;

			const item = _.get(section, `children.${itemIndex}`, null);
			if (!item) {
				return item;
			}

			result.item = item;
		}
	} catch (e) {
		console.warn(e);
	}
	return result;

}

export function getContextItems(currentItem = state.get(["activity", "selected"])) {
	let items = [];
	const { listIndex, sectionIndex, itemIndex } = currentItem;
	const sectionChildren = state.get(["activity", "children", listIndex, "children", sectionIndex, "children"]);
	sectionChildren.forEach((item, idx) => {
		if (Utils.isVisible(item)) {
			const _item = _.clone(item);
			_item._idx = idx;
			if (itemIndex !== idx) {
				items.push(_item);
			} else {
				_item.contextSelected = true;
				items.push(_item);
			}
		}
	});

	return items;
}

export function getContextSections(currentItem = state.get(["activity", "selected"])) {
	let items = [];
	const { listIndex, sectionIndex } = currentItem;
	const listChildren = state.get(["activity", "children", listIndex, "children"]);
	listChildren.forEach((section, idx) => {
		if (Utils.isVisible(section)) {
			const _section = _.clone(section);
			_section._idx = idx;
			if (sectionIndex !== idx) {
				items.push(_section);
			} else {
				_section.contextSelected = true;
				items.push(_section);
			}
		}
	});

	return items;
}

export function getContextLists(currentItem = state.get(["activity", "selected"])) {
	let items = [];
	const { listIndex } = currentItem;
	const activityChildren = state.get(["activity", "children"]);
	activityChildren.forEach((list, idx) => {
		if (Utils.isVisible(list)) {
			const _list = _.clone(list);
			_list._idx = idx;
			if (listIndex !== idx) {
				items.push(_list);
			} else {
				_list.contextSelected = true;
				items.push(_list);
			}
		}
	});

	return items;
}

export function setScrollToSelectedItem(tree, scroll) {
	tree.set(["player", "scrollToSelectedItem"], scroll);
}

export function setStoreCloudHistory(tree, storeCloudHistory) {
	tree.set(["storeCloudHistory"], storeCloudHistory);
}

export function setFocusedMode(tree, focusedMode) {
	tree.set(["focusedMode"], focusedMode);
}

export function setMoveForward(tree, moveForward) {
	tree.set(["moveForward"], moveForward);
}

export function setCheckbarLocation(tree, checkbarLocation) {
	tree.set(["appPreferences", "checkbarLocation"], checkbarLocation);
}

export function setCheckedColor(tree, checkedColor) {
	tree.set(["appPreferences", "checkedColor"], checkedColor);
}

export function setDefaultColumnWidth(tree, defaultColumnWidth) {
	tree.set(["appPreferences", "defaultColumnWidth"], defaultColumnWidth);
	tree.set(["dimensions", "listLargestColumnWidth"], defaultColumnWidth);
}

export function showHideNavigationView(tree, visible, placement = "left") {

	tree.set(PlayerPaths.SHOW_NAVIGATION_VIEW, visible);
	tree.set(PlayerPaths.SHOW_NAVIGATION_VIEW_PLACEMENT, placement);
}

export function showPromptModalMoveForward(tree) {
	SyntheticVoiceApi.stop();
	SyntheticVoiceApi.speak(tree.get(["content"]).alerts.skippedItems);
	tree.set(PlayerPaths.PROMPT_MODAL_MOVE_FORWARD_VISIBLE, true);
}

export function moveForward(tree) {

	SyntheticVoiceApi.stop();
	let listIndex = tree.get(["activity", "selected", "listIndex"]);

	if (findNextItemNotChecked(tree)) {
		if (typeof resultFindItem.listIndex !== "undefined" && typeof resultFindItem.sectionIndex !== "undefined" && typeof resultFindItem.itemIndex !== "undefined") {
			let resultListIndex = resultFindItem.listIndex;
			let resultSectionIndex = resultFindItem.sectionIndex;
			let resultItemIndex = resultFindItem.itemIndex;

			if (listIndex !== resultListIndex) {
				setSelectedListIndex(tree, resultFindItem.listIndex);
			}
			ensureExpanded(tree, resultListIndex, resultSectionIndex);
			setSelectedItemAndSpeak(tree, resultListIndex, resultSectionIndex, resultItemIndex, true);
		}
	}

	tree.set(PlayerPaths.PROMPT_MODAL_MOVE_FORWARD_VISIBLE, false);
}

export function returnToSkippedItems(tree) {

	SyntheticVoiceApi.stop();
	let listIndex = tree.get(["activity", "selected", "listIndex"]);
	let sectionIndex = tree.get(["activity", "selected", "sectionIndex"]);

	// All items not complete in section so go find first one in section not complete
	if (findNextItemNotChecked(tree, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: 0 })) {
		// TODO: Not ideal...really need to figure out recursion with good return values
		if (typeof resultFindItem.listIndex !== "undefined" && typeof resultFindItem.sectionIndex !== "undefined" && typeof resultFindItem.itemIndex !== "undefined") {
			let resultListIndex = resultFindItem.listIndex;
			let resultSectionIndex = resultFindItem.sectionIndex;
			let resultItemIndex = resultFindItem.itemIndex;

			setSelectedListIndex(tree, resultFindItem.listIndex);
			setSelectedItemAndSpeak(tree, resultListIndex, resultSectionIndex, resultItemIndex, true);
		}
	}

	tree.set(PlayerPaths.PROMPT_MODAL_MOVE_FORWARD_VISIBLE, false);
}

// Can potentially reuse this function for lists and checklist as well
export function getSectionCompletionState(tree, section, includeVisible = false) {
	// // console.log(" In " + arguments.callee.name);
	let items = section.children;
	let checkedCount = 0;
	let ignoreCompletionCount = 0;
	for (let i = 0, len = items.length; i < len; i++) {
		if ((items[i].hasOwnProperty("ignoreCompletion") && items[i].ignoreCompletion) || (includeVisible && !Utils.isVisible(items[i]))) {
			// if ((items[i].hasOwnProperty("ignoreCompletion") && items[i].ignoreCompletion) || !Utils.isVisible(items[i])) {
			ignoreCompletionCount++;
		} else {
			if (items[i].checked) {
				checkedCount++;
			}
		}
	}

	if (checkedCount === 0) {
		return "n";
	} else if (checkedCount < (items.length - ignoreCompletionCount)) {
		return "i";
	} else {
		let listIndex = tree.get(["activity", "selected", "listIndex"]);
		let sectionIndex = tree.get(["activity", "selected", "sectionIndex"]);

		const section = tree.get(["activity", "children", listIndex, "children", sectionIndex]);

		if (section.completionState !== "c") {
			const suffix = getSectionNameAudioWithSuffix(tree, listIndex, sectionIndex, true);
			if (suffix !== "") {
				const suppressAudio = !!section.suppressAudio;
				const suppressAudioCompletion = !!section.suppressAudioCompletion;
				if (!suppressAudio && !suppressAudioCompletion) {
					SyntheticVoiceApi.speak(suffix + " is complete.");
				}
			}
		}

		return "c";
	}
}

export function setCheckbarSize(tree, size) {
	tree.set(["appPreferences", "checkbarSize"], size);
}

export function getSelectedItem(currentItem = state.get(["activity", "selected"]), activity = null) {
	let result = {};
	try {
		if (currentItem) {
			result = activity ? _.get(activity, `children.${currentItem.listIndex}.children.${currentItem.sectionIndex}.children.${currentItem.itemIndex}`, {}) : state.get(["activity", "children", currentItem.listIndex, "children", currentItem.sectionIndex, "children", currentItem.itemIndex]);
		}
	} catch (e) {
		console.warn(e);
	}
	return result;
}

/**
 * AUDIO Capabilities
 */


export function getListNameAudioWithSuffix(tree, listIndex, forceTitle = false) {
	const list = tree.get(["activity", "children", listIndex]);
	const suppressAudioEntityType = list.hasOwnProperty("suppressAudioEntityType") ? !!list.suppressAudioEntityType : false;
	const listNameAudio = getNameAudio(list, forceTitle);

	let listSuffix = "";
	if (!listNameAudio.toLowerCase().endsWith("list")) {
		listSuffix = " " + tree.get(["content"]).mira.speaks.list;
	}
	const result = `${listNameAudio}${!suppressAudioEntityType ? listSuffix : ""}`;
	// console.log("getListNameAudioWithSuffix", result);
	return result;
}

// let suppressCache = {};

function speakListAudio(tree, listIndex) {
	const suppressAudio = !!state.get(["activity", "children", listIndex, "suppressAudio"]);
	const suppressAudioTitle = !!state.get(["activity", "children", listIndex, "suppressAudioTitle"]);
	if (!suppressAudio && !suppressAudioTitle) {
		const list = tree.get(["activity", "children", listIndex]);
		const suppressAudioEntityType = list.hasOwnProperty("suppressAudioEntityType") ? !!list.suppressAudioEntityType : false;
		// console.log("Speak list audio", {
		// 	prop: ["name"],
		// 	suffix: tree.get(["content"]).mira.speaks.list,
		// 	addSuffix: !suppressAudioEntityType
		// });
		SyntheticVoiceApi.speakList(list, {
			prop: ["name"],
			suffix: tree.get(["content"]).mira.speaks.list,
			addSuffix: !suppressAudioEntityType
		});
	}
}

export function getSectionNameAudioWithSuffix(tree, listIndex, sectionIndex, forceTitle = false) {
	const section = tree.get(["activity", "children", listIndex, "children", sectionIndex]);
	const suppressAudioEntityType = section.hasOwnProperty("suppressAudioEntityType") ? !!section.suppressAudioEntityType : false;
	const sectionNameAudio = getNameAudio(section, forceTitle);


	if (sectionNameAudio !== "") {
		let sectionSuffix = "";
		if (!sectionNameAudio.toLowerCase().endsWith("section")) {
			sectionSuffix = " " + tree.get(["content"]).mira.speaks.section;
		}

		return `${sectionNameAudio}${!suppressAudioEntityType ? sectionSuffix : ""}`;
	} else {
		return "";
	}
}

function speakSectionAudio(tree, listIndex, sectionIndex) {
	const suppressAudio = !!state.get(["activity", "children", listIndex, "children", sectionIndex, "suppressAudio"]);
	const suppressAudioTitle = !!state.get(["activity", "children", listIndex, "children", sectionIndex, "suppressAudioTitle"]);
	if (!suppressAudio && !suppressAudioTitle) {
		const section = tree.get(["activity", "children", listIndex, "children", sectionIndex]);
		const suppressAudioEntityType = section.hasOwnProperty("suppressAudioEntityType") ? !!section.suppressAudioEntityType : false;
		SyntheticVoiceApi.speakSection(section, {
			prop: ["name"],
			suffix: tree.get(["content"]).mira.speaks.section,
			addSuffix: !suppressAudioEntityType
		});
	}
}

export function getNameAudio(item, forceTitle = false) {
	// console.log("getNameAudio", item);
	const suppressAudioTitle = !!item.suppressAudioTitle && !forceTitle;
	if (suppressAudioTitle) {
		// console.log("SUPPRESS AUDIO TITLE");
		return "";
	} else {
		if (item.hasOwnProperty("nameAudio") && item.nameAudio !== "") {
			// console.log("getNameAudio (item.nameAudio)", item.nameAudio);
			return item.nameAudio;
		} else {
			// console.log("getNameAudio Utils.getRealName(item.name)", Utils.getRealName(item.name));
			return Utils.getRealName(item.name);
		}
	}
}

export function getLabel1Audio(item) {
	// // console.log(" In " + arguments.callee.name);

	const suppressAudioLabel1 = !!item.suppressAudioLabel1;
	if (suppressAudioLabel1) {
		return "";
	} else {
		if (item.hasOwnProperty("label1Audio") && item.label1Audio !== "") {
			return item.label1Audio;
		} else {
			return item.label1;
		}
	}
}

export function getLabel2Audio(item) {
	// // console.log(" In " + arguments.callee.name);
	const suppressAudioLabel2 = !!item.suppressAudioLabel2;
	if (suppressAudioLabel2) {
		return "";
	} else {
		if (item.hasOwnProperty("label2Audio") && item.label2Audio !== "") {
			return item.label2Audio;
		} else {
			return item.label2;
		}
	}
}


function speakItem(tree, item, itemLocation) {
	// if (item.audio) {
	// 	const audioSource = getResourceUrlForResourceRef(null, item.audio, true, true);

	// 	SoundUtils.play(audioSource);
	// } else {
	// // console.log(" In " + arguments.callee.name);
	// console.log("Speak item requested", item);
	let checkLabel = tree.get(["appPreferences", "voice", "checkLabel"]);
	const suppressAudio = !!item.suppressAudio;
	if (!suppressAudio && tree.get("appPreferences", "voice", "audio")) {
		const prop = ["label1"];
		if (item.type.startsWith("item")) {
			let challengeResponseMode = tree.get(["appPreferences", "voice", "challengeResponseMode"]);
			if ((item.labelOnly || !challengeResponseMode) && (checkLabel || (item.label2 !== tree.get(["content"]).mira.responses.check))) {
				prop.push("label2");
			}
		}

		SyntheticVoiceApi.speakItem(item, { prop }, null, itemLocation);
		// }
	}
}


export function setSectionsCollapsed(tree, listIndex, collapsed) {
	setSelectedItem(tree, listIndex, 0, 0, true);

	// console.log(" In " + arguments.callee.name);
	let sections = tree.get(["activity", "children", listIndex, "children"]);
	for (let i = 0; i < sections.length; i++) {
		let sectionCollapsed = ["activity", "children", listIndex, "children", i, "expanded"];
		console.log("SET SECTION COLLAPSED (2)", collapsed);
		tree.set(sectionCollapsed, !collapsed);
	}

	//saveCurrentChecklistToStore(tree);
}

export function setSelectedListIndexAndSpeak(tree, index, forceBirdseyeView = false) {
	console.log("****** In setSelectedListIndexAndSpeak");
	SyntheticVoiceApi.stop();
	// // console.log(" In " + arguments.callee.name);
	if (index >= 0) {
		tree.set(["session"], tree.get(["session"]) + 1);

		setSelectedListIndex(tree, index);

		let selectedListIndex = tree.get(["activity", "selectedListIndex"]);

		let listIndex = tree.get(["activity", "selected", "listIndex"]);
		let sectionIndex = tree.get(["activity", "selected", "sectionIndex"]);
		let itemIndex = tree.get(["activity", "selected", "itemIndex"]);

		let checklist = tree.get(["activity"]);

		const startInBirdseyeView = checklist.children[selectedListIndex].hasOwnProperty("startInBirdseyeView") ? checklist.children[selectedListIndex].startInBirdseyeView : false;

		if (checklist.children[selectedListIndex].defaultView === "onePageView"/* && !startInBirdseyeView*/) {
			setSectionsCollapsed(tree, index, true);
		}


		if (startInBirdseyeView || forceBirdseyeView) {
			SyntheticVoiceApi.stop();
			// SyntheticVoiceApi.speak("Birdseye view of " + getNameAudio(tree.get(["activity"]).children[index]) + " " + tree.get(["content"]).mira.speaks.list);

			setSectionsMenuVisible(tree, true);
		} else {
			setSectionsMenuVisible(tree, false);

			let section = tree.get(["activity", "children", listIndex, "children", sectionIndex]);

			if (section.expanded) {
				SyntheticVoiceApi.stop();
				speakListAudio(tree, selectedListIndex);
				if (selectedListIndex === listIndex) {
					// console.log("setSelectedListIndexAndSpeak");
					speakSectionAudio(tree, listIndex, sectionIndex);

					let item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
					speakItem(tree, item);
				}
			}
		}

	}
}

export function setPreviousSelectedListIndexAndSpeak(tree) {

	let selectedListIndex = tree.get(["activity", "selectedListIndex"]);

	if (selectedListIndex > 0) {
		setSelectedListIndexAndSpeak(tree, selectedListIndex - 1);
	}
}

export function setNextSelectedListIndexAndSpeak(tree) {
	// // console.log(" In " + arguments.callee.name);
	let numLists = tree.get(["activity", "children"]).length;

	let selectedListIndex = tree.get(["activity", "selectedListIndex"]);

	if (selectedListIndex < numLists - 1) {
		setSelectedListIndexAndSpeak(tree, selectedListIndex + 1);
	}
}

export function readComments(tree) {
	// // console.log(" In " + arguments.callee.name);
	let selectedListIndex = tree.get(["activity", "selectedListIndex"]);
	let selectedSectionIndex = tree.get(["activity", "selected", "sectionIndex"]);
	let selectedItemIndex = tree.get(["activity", "selected", "itemIndex"]);
	let selectedItem = tree.get(["activity", "children", selectedListIndex, "children", selectedSectionIndex, "children", selectedItemIndex]);

	SyntheticVoiceApi.stop();
	if (selectedItem.comments === null || selectedItem.comments === "") {
		SyntheticVoiceApi.speak("Sorry, you don't have any comments.");
	} else {
		SyntheticVoiceApi.speak(selectedItem.comments);
	}
}

export function readNotes(tree) {
	// // console.log(" In " + arguments.callee.name);
	let selectedListIndex = tree.get(["activity", "selectedListIndex"]);
	let selectedSectionIndex = tree.get(["activity", "selected", "sectionIndex"]);
	let selectedItemIndex = tree.get(["activity", "selected", "itemIndex"]);
	let selectedItem = tree.get(["activity", "children", selectedListIndex, "children", selectedSectionIndex, "children", selectedItemIndex]);

	SyntheticVoiceApi.stop();
	if (selectedItem.notes === null || selectedItem.notes === "") {
		SyntheticVoiceApi.speak("Sorry, you don't have any notes.");
	} else {
		SyntheticVoiceApi.speak(selectedItem.notes);
	}
}

let voicesInit = false;
export function setVoices(voices) {
	const _voices = [];
	if (!voicesInit) {
		const mac = navigator.appVersion.indexOf("Mac") !== -1;
		console.log("Voices init:", voices);
		console.log("Voices init, is Mac?", mac);
		let foundVoices = false;
		let googleFemale = null;
		let googleFemaleVoice = null;
		let googleMale = null;
		voices.forEach(voice => {

			const { default: def, name, lang, localService, voiceUri } = voice;
			console.log("Voice init, loop", voice);
			_voices.push({
				def,
				name,
				lang,
				localService,
				voiceUri
			});
			if (name) {
				console.log("Setting default voices", name);
				if (name.toLowerCase() === "samantha") {
					setPrimaryVoice("Samantha", voice);
					foundVoices = true;
				} else if (name.toLowerCase() === "daniel") {
					setSecondaryVoice("Daniel");
				} else
					if (name.toLowerCase() === "google uk english female") {
						googleFemale = "Google UK English Female";
						googleFemaleVoice = voice;
					} else if (name.toLowerCase() === "google us english") {
						googleMale = "Google US English";
					}
			}

		});

		if (!foundVoices && googleFemale && googleFemaleVoice && googleMale) {
			setPrimaryVoice(googleFemale, googleFemaleVoice);
			setSecondaryVoice(googleMale);
		}

		console.log("Voices set", _voices);
		state.set(["appPreferences", "voice", "voices", "list"], _voices);
	}
	voicesInit = true;
}

export function getVoiceForName(name) {
	return getVoiceByPropertyValue("name", name);
}

export function getDefaultVoice() {
	return getVoiceByPropertyValue("default", true);
}

function getVoiceByPropertyValue(prop, val) {
	let result = null;
	const voices = state.get(["appPreferences", "voice", "voices", "list"]);
	console.log("Get voice by property", voices, prop, val);
	if (voices && _.isArray(voices)) {
		result = _.find(window.speechSynthesis.getVoices(), (o) => { return o[prop] === val; });
	}
	return result;
}

export function setPrimaryVoice(primaryVoiceName, primaryVoice = null) {
	if (!primaryVoice) {
		primaryVoice = getVoiceForName(primaryVoiceName);
	}

	if (primaryVoice) {
		SyntheticVoiceApi.setDefaultVoice(primaryVoice);
	}
	state.set(["appPreferences", "voice", "voices", "primary"], primaryVoiceName);
	savePreferences();
}

export function setSecondaryVoice(secondaryVoiceName) {
	state.set(["appPreferences", "voice", "voices", "secondary"], secondaryVoiceName);
	console.log("Set voices secondary", secondaryVoiceName);
	savePreferences();

	console.log("Set voices secondary", secondaryVoiceName, " done");
}

export function setVoiceSpeed(tree = state, voiceSpeed) {
	tree.set(["appPreferences", "voice", "speed"], voiceSpeed);
	SyntheticVoiceApi.setDefaultSpeed(voiceSpeed);
}

export function cancelVoice() {
	SyntheticVoiceApi.stop();
}

// let srs = [];
// let stop = false;
// let audioInterval = null;

let speaker = null;

export function addSpeechRequest(...sr) {
	if (speaker) {
		speaker.addSpeechRequest(...sr);
	}
}

export function stopSpeech() {
	if (speaker) {
		speaker.stopSpeech();
	}
}

export function generateNewSpeaker(stopped=false) {
	speaker = {
		addSpeechRequest: (...sr) => {
			if (stopped) {
				window.speechSynthesis.speak(window.utterance);
				stopped = false;
					SyntheticVoiceApi.doSpeak(...sr);
			} else {

				SyntheticVoiceApi.doSpeak(...sr);
			}
		},
		stopSpeech: () => {

			SyntheticVoiceApi.doStop();
			console.log("About to generate new speech synthesis");
			window.utterance = new SpeechSynthesisUtterance(" ");
			window.speechSynthesis.speak(window.utterance);
			stopped = true;
			generateNewSpeaker(true);
			// window.utterance = new SpeechSynthesisUtterance(".stop.");
			// window.speechSynthesis.speak(window.utterance);
		}
	};
}

export function setAudioOn(tree = state) {
	// // console.log(" In " + arguments.callee.name);
	return new Promise((resolve, reject) => {
		try {
			const lang = getQueryStringParam("lang");


			/**
			 * THIS IS THE COST OF SPEECH SYNTHESIS REQUIRING USER ACTION
			 * The below code is odd, and it represents a workaround for iOS 13.4
			 * where Apple locked down Safari to require user actions to allow speech synthesis.
			 * This function is called from "Activate Narration" button click event.
			 * We are instantly speaking to tie this event to speech synthesis and launch a loop,
			 * this loop will "observe" an array that will be filled with speech requests, and also
			 * a flag indicating if audio must be stopped.
			 * Then ever 300ms we see if the stop flag is true or there are speech requests in the Array.
			 * Because this closure is in scope of a user event it appears Safari is content to keep talking
			 * so long as all speech is "funnelled" through this interval ...
			 */

			tree.set(["appPreferences", "voice", "audio"], true);
			window.utterance = new SpeechSynthesisUtterance(lang === "es" ? "Narración activa" : "Narration active");
			window.speechSynthesis.speak(window.utterance);

			generateNewSpeaker();

			// audioInterval = setInterval(() => {
			// 	if (stop) {
			// 		SyntheticVoiceApi.doStop();
			// 		window.speechSynthesis.speak("stop");
			// 		stop = false;
			// 	}
			// 	srs.forEach(sr => {
			// 		SyntheticVoiceApi.doSpeak(...sr);
			// 	});
			// 	srs = [];
			// }, 300);
			setTimeout(() => {
				SyntheticVoiceApi.speakAudio([
					"init"
				]);
				savePreferences(tree);
				
				resolve();
			}, 1500);
		} catch (e) {
			reject(e);
		}
	});
}

export function setAudioOff(tree = state) {
	// // console.log(" In " + arguments.callee.name);
	return new Promise((resolve, reject) => {
		try {
			tree.set(["appPreferences", "voice", "audio"], false);
			SyntheticVoiceApi.stop();
			savePreferences(tree);
			resolve();
		} catch (e) {
			reject(e);
		}
	});
}

export function setAudio(tree = state, audio) {
	// // console.log(" In " + arguments.callee.name);
	if (!audio) {
		return setAudioOff(tree);
	} else {
		return setAudioOn(tree);
	}
}

export function toggleAudio(tree = state) {
	// // console.log(" In " + arguments.callee.name);
	const audio = !tree.get(["appPreferences", "voice", "audio"]);
	return setAudio(tree, audio);
}

export function setSayCheck(tree = state, sayCheck) {
	tree.set(["appPreferences", "voice", "sayCheck"], sayCheck);
}


export function savePreferences(tree = state) {
	// // console.log(" In " + arguments.callee.name);
	let prefs = {};

	prefs.checklistView = tree.get(["checklistView"]);
	prefs.appPreferences = tree.get(["appPreferences"]);
	prefs.focusedMode = tree.get(["focusedMode"]);
	prefs.moveForward = tree.get(["moveForward"]);
	prefs.tracking = tree.get(["tracking"]);
	prefs.storeCloudHistory = tree.get(["storeCloudHistory"]);
	prefs.useGrammar = tree.get(["useGrammar"]);
	prefs.showVoiceCommands = tree.get(["showVoiceCommands"]);
	prefs.listeningAggressive = tree.get(["listeningAggressive"]);
	prefs.listeningBackgroundNoise = tree.get(["listeningBackgroundNoise"]);
	prefs.miraListeningDelay = tree.get(["miraListeningDelay"]);
	prefs.interruptMira = tree.get(["interruptMira"]);
	prefs.miraSnarky = tree.get(["miraSnarky"]);
	prefs.btCompat = tree.get(["btCompat"]);
	prefs.acousticModel = tree.get(["acousticModel"]);
	prefs.audioMode = tree.get(["audioMode"]);
	if (tree.get(["subscription"]) !== "pro-plan-timed") {
		prefs.subscription = tree.get(["subscription"]);
		prefs.nightMode = tree.get(["nightMode"]);
	}
	prefs.subscriptionExpiration = tree.get(["subscriptionExpiration"]);
	prefs.subscriptionTransactionId = tree.get(["subscriptionTransactionId"]);

	prefs.gotIt = tree.get(["gotIt"]);
	prefs.consent = tree.get(["consent"]);
	prefs.previewProCount = tree.get(["previewProCount"]);
	//prefs.listening = tree.get(["listening"]);
	prefs.echoCancellation = tree.get(["echoCancellation"]);
	prefs.listenInBackground = tree.get(["listenInBackground"]);
	prefs.uploadVoice = tree.get(["uploadVoice"]);
	prefs.limitVocab = tree.get(["limitVocab"]);

	let user = tree.get(["lastUser"]);
	let identityId = "anonymous";
	if (user) {
		identityId = user.identityId + ":";
	}

	const { localStorage } = window;
	// console.log("Saving preferences", identityId, prefs);
	localStorage.setItem(identityId + "preferences", JSON.stringify(prefs));
}

export function setSectionsMenuVisible(tree, sectionsMenuVisible) {
	if (tree === null) {
		tree = state;
	}

	if (sectionsMenuVisible) {
		SyntheticVoiceApi.stop();
		// const index = tree.get(["currentChecklist","selectedListIndex"])
		// SyntheticVoiceApi.speak("Birdseye view of " + getNameAudio(tree.get(["currentChecklist"]).children[index]) + " " + tree.get(["content"]).mira.speaks.list);
	}

	if (tree.get(["appState", "sectionsMenuVisible"]) !== sectionsMenuVisible) {
		tree.set(["appState", "sectionsMenuVisible"], sectionsMenuVisible);


		// if (!sectionsMenuVisible && isSelectedVisible(tree)) {
		// 	showSelectedItem(tree);
		// }
	}
}

export function isSelectedVisible(tree = state) {
	// console.log(" In " + arguments.callee.name);
	const selectedListIndex = tree.get(["activity", "selectedListIndex"]);
	const selectedSectionIndex = tree.get(["activity", "selected", "sectionIndex"]);

	const sectionCollapsed = !tree.get(["activity", "children", selectedListIndex, "children", selectedSectionIndex, "expanded"]);

	if (sectionCollapsed) {
		return false;
	} else {
		return true;
	}
}

export function toggleSectionsMenuVisible(tree) {
	const sectionsMenuVisible = tree.get(["appState", "sectionsMenuVisible"]);

	setSectionsMenuVisible(tree, !sectionsMenuVisible);
}

export function gotoItemFromSectionsMenu(tree, listIndex, sectionIndex/*, itemIndex, speakSectionItems=false*/) {
	const listDefaultView = Utils.getListDefaultView(tree, listIndex);

	if (listDefaultView === "onePageView") {
		setSectionsCollapsed(tree, listIndex, true);
	}

	// if (speakSectionItems) {
	// 	showModalPauseResume(tree);
	// 	speakSection(tree,listIndex,sectionIndex);    

	// 	setTimeout(function() {
	// 		setSectionsMenuVisible(tree,false);
	// 	},0);
	// } else {
	if (findNextItemNotChecked(tree, { listIndex: listIndex, sectionIndex: sectionIndex, itemIndex: 0 })) {
		if (typeof resultFindItem.listIndex !== "undefined" && typeof resultFindItem.sectionIndex !== "undefined" && typeof resultFindItem.itemIndex !== "undefined") {
			let resultListIndex = resultFindItem.listIndex;
			let resultSectionIndex = resultFindItem.sectionIndex;
			let resultItemIndex = resultFindItem.itemIndex;

			if (resultListIndex !== listIndex || resultSectionIndex !== sectionIndex) {
				resultListIndex = listIndex;
				resultSectionIndex = sectionIndex;
				resultItemIndex = 0;
			}

			setSectionsMenuVisible(tree, false);

			ensureExpanded(tree, resultListIndex, resultSectionIndex);

			setTimeout(function () {
				setSelectedItemAndSpeak(tree, resultListIndex, resultSectionIndex, resultItemIndex, true);
			}, 300);
		}
	} else {
		setTimeout(function () {
			setSectionsMenuVisible(tree, false);
		}, 0);
	}
	// }
}


export function gotoItemAndSpeak(tree, listIndex, sectionIndex, itemIndex, speakSection = false, selectList = false) {
	console.log("****** In gotoItemAndSpeak");

	// console.log("GOTO ITEM AND SPEAK");
	let selectedListIndex = tree.get(["activity", "selected", "listIndex"]);
	let selectedSectionIndex = tree.get(["activity", "selected", "sectionIndex"]);
	// let selectedItemIndex = tree.get(["activity", "selected", "itemIndex"]);

	const result = gotoItem(tree, listIndex, sectionIndex, itemIndex, speakSection, selectList);

	if (selectedListIndex !== listIndex) {
		// console.log("gotoItemAndSpeak");
		speakListAudio(tree, listIndex);
		speakSectionAudio(tree, listIndex, sectionIndex);
	} else if (selectedSectionIndex !== sectionIndex) {
		// console.log("gotoItemAndSpeak");
		speakSectionAudio(tree, listIndex, sectionIndex);
	}

	let item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
	speakItem(tree, item);
	return result;
}

export function handleGoBack() {
	let listIndex = state.get(["activity", "selected", "listIndex"]);
	let sectionIndex = state.get(["activity", "selected", "sectionIndex"]);
	let itemIndex = state.get(["activity", "selected", "itemIndex"]);
	let item = state.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);

	if (item.type === "itemYesNo") {
		gotoLinkYesNo(state, "no");
	} else {
		if (state.get(["appState", "modalShowModeVisible"]) && window.globalShowMode.showModeInstance) {
			if (window.globalShowMode.showModeInstance.isFirstSlide()) {
				SyntheticVoiceApi.stop();
				SyntheticVoiceApi.speak("You are on the first item.");
			} else {
				window.globalShowMode.showModeInstance.navigateBack();
			}
		} else {
			gotoPreviousItem(state);
		}
	}
}


export function handleSkip() {
	let listIndex = state.get(["activity", "selected", "listIndex"]);
	let sectionIndex = state.get(["activity", "selected", "sectionIndex"]);
	let itemIndex = state.get(["activity", "selected", "itemIndex"]);
	let item = state.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);

	if (item.type === "itemYesNo") {
		gotoLinkYesNo(state, "no");
	} else {
		if (state.get(["appState", "modalShowModeVisible"]) && window.globalShowMode.showModeInstance) {
			if (window.globalShowMode.showModeInstance.isFirstSlide()) {
				SyntheticVoiceApi.stop();
				SyntheticVoiceApi.speak("You are on the first item.");
			} else {
				window.globalShowMode.showModeInstance.navigateBack();
			}
		} else {
			skipItem(state);
		}
	}
}

function getItem(tree = state, listIndex, sectionIndex, itemIndex) {
	let currentChecklist = tree.get(["activity"]);
	if (!currentChecklist || !currentChecklist.hasOwnProperty("selected")) {
		return null;
	}

	return tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
}

export function gotoLinkPicker(tree, index) {
	const identityId = tree.get(["user", "identityId"]);

	let listIndex = tree.get(["activity", "selected", "listIndex"]);
	let sectionIndex = tree.get(["activity", "selected", "sectionIndex"]);
	let itemIndex = tree.get(["activity", "selected", "itemIndex"]);

	let item = Utils.getItem(tree, listIndex, sectionIndex, itemIndex);

	if (item.type !== "itemPicker") {
		return;
	}

	let pickerItems = item.pickerItems;

	if (index < pickerItems.length) {
		let li = Utils.getLinkInfo(item, pickerItems[index].value);

		if (li !== null) {
			setTimeout(() => {
				setItemPickerChecked(tree, listIndex, sectionIndex, itemIndex, pickerItems[index].value, identityId, li.linkOnSelect, li.linkId, li.linkActionType);
			});
		}
	}
}

export function gotoLinkYesNo(tree, value) {
	let listIndex = tree.get(["activity", "selected", "listIndex"]);
	let sectionIndex = tree.get(["activity", "selected", "sectionIndex"]);
	let itemIndex = tree.get(["activity", "selected", "itemIndex"]);

	let item = getItem(tree, listIndex, sectionIndex, itemIndex);

	if (item.type !== "itemYesNo") {
		return;
	}

	let linkOnSelect = (item.hasOwnProperty("yesNoLinkOnSelect") ? item.yesNoLinkOnSelect : false);
	let yesLinkId = (item.hasOwnProperty("yesNoYesLinkId") ? item.yesNoYesLinkId : "");
	let noLinkId = (item.hasOwnProperty("yesNoNoLinkId") ? item.yesNoNoLinkId : "");
	let naLinkId = (item.hasOwnProperty("yesNoNaLinkId") ? item.yesNoNaLinkId : "");
	let linkActionType = (item.hasOwnProperty("yesNoLinkActionType") ? item.yesNoLinkActionType : "goto");

	setItemYesNoChecked(tree, listIndex, sectionIndex, itemIndex, value, linkOnSelect, linkActionType, yesLinkId, noLinkId, naLinkId);
}
export function setSelectedItemAndSpeak(tree, listIndex, sectionIndex, itemIndex, autoScroll = false, speakSection = false, tries = 0, includeList = true) {
	console.log("****** In setSelectedItemAndSpeak");
	if (setSelectedItem(tree, listIndex, sectionIndex, itemIndex, autoScroll, speakSection, tries)) {
		speakSelectedItem(tree, includeList);
	}
}


export function speakSelectedItem(tree, includeList = true) {
	console.log("****** In speakSelectedItem");

	// // console.log(" In " + arguments.callee.name);
	if (tree.get(["appPreferences", "voice", "audio"])) {
		// console.log("SPEAK SELECTED ITEM", item);
		let listIndex = tree.get(["activity", "selectedListIndex"]);
		let sectionIndex = tree.get(["activity", "selected", "sectionIndex"]);
		let itemIndex = tree.get(["activity", "selected", "itemIndex"]);

		// Make sure have valid item
		if (_.isUndefined(listIndex) || listIndex === null) {
			return;
		}

		let firstLevel = tree.get(["activity", "firstLevel"]);

		if (includeList) {
			if (sectionIndex === 0 && itemIndex === 0 && firstLevel === "lists") {
				speakListAudio(tree, listIndex);
			}
		}

		if (itemIndex === 0 && (firstLevel === "lists" || firstLevel === "sections")) {
			// console.log("speakSelectedItem");
			speakSectionAudio(tree, listIndex, sectionIndex);
		}

		let item = tree.get(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex]);
		speakItem(tree, item, { listIndex, sectionIndex, itemIndex });
	}
}

export function showSketchPad(tree, listIndex, sectionIndex, itemIndex, item) {
	initializeSketchPad(tree, listIndex, sectionIndex, itemIndex, item);
	tree.set(PlayerPaths.SKETCH_PAD_PROPERTY("show"), true);
}

export function hideSketchPad(tree) {
	// console.log(" In " + arguments.callee.name);
	saveSketchPad(tree);
	tree.set(PlayerPaths.SKETCH_PAD_PROPERTY("show"), false);
}

export function saveSketchPad(tree) {

	try {
		//if (window.hasOwnProperty("globalCanvas")) {
		// console.log(window.globalCanvas.getPaths());

		let selectedListIndex = tree.get(PlayerPaths.ACTIVITY_PROPERTY("selectedListIndex"));
		let selectedSectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
		let selectedItemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);


		if (window.globalCanvas) {

			let sketchPadSaveData = JSON.parse(window.globalCanvas.getSaveData());
			let sketchPadDimensions = { width: sketchPadSaveData.width, height: sketchPadSaveData.height };

			if (sketchPadSaveData.lines.length > 0) {

				try {
					const sketchPadImage = window.globalCanvas.canvasContainer.children[1].toDataURL();
					tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "sketchPadImage"), sketchPadImage);
					tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "sketchPadImagePaths"), transformSketchPadImagePathsFromPlayer(sketchPadSaveData.lines, sketchPadDimensions));
					tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "sketchPadDimensions"), sketchPadDimensions);

					historyActions.setSketchPad(tree, selectedListIndex + "," + selectedSectionIndex + "," + selectedItemIndex, sketchPadImage, tree.get(["user"]).identityId);

				} catch (e) {
					// console.log(e);
					showError("Error", "Unable to get image " + e);
				}
			}
		} else {
			tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "sketchPadImage"), null);
			tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "sketchPadImagePaths"), []);
			tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "sketchPadImagePaths"), null);
		}

		//}  
	} catch (e) {
		// console.log(e);
	}
}

export function initializeSketchPad(tree, listIndex, sectionIndex, itemIndex, item) {
	setSelectedItem(tree, listIndex, sectionIndex, itemIndex, true);
	// console.log(" In " + arguments.callee.name);
	tree.set(["player", "sketchPad", "item"], item);
}

/*
export function saveSketchPadImage(tree, itemIndices, sketchPadImagePaths, sketchPadImage, sketchPadDimensions) {
	if (sketchPadImagePaths && sketchPadImagePaths.length === 0) {
		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(itemIndices.listIndex, itemIndices.sectionIndex, itemIndices.itemIndex, "sketchPadImage"), null);
		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(itemIndices.listIndex, itemIndices.sectionIndex, itemIndices.itemIndex, "sketchPadImagePaths"), []);
		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(itemIndices.listIndex, itemIndices.sectionIndex, itemIndices.itemIndex, "sketchPadDimensions"), null);
		History.clearSketchPad(tree, itemIndices.listIndex + "," + itemIndices.sectionIndex + "," + itemIndices.itemIndex, sketchPadImage);
	} else {
		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(itemIndices.listIndex, itemIndices.sectionIndex, itemIndices.itemIndex, "sketchPadImage"), sketchPadImage);
		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(itemIndices.listIndex, itemIndices.sectionIndex, itemIndices.itemIndex, "sketchPadImagePaths"), sketchPadImagePaths);
		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(itemIndices.listIndex, itemIndices.sectionIndex, itemIndices.itemIndex, "sketchPadDimensions"), sketchPadDimensions);
		History.setSketchPad(tree, itemIndices.listIndex + "," + itemIndices.sectionIndex + "," + itemIndices.itemIndex, sketchPadImage);
	}

}

export function saveSketchPadForItem(tree) {
	// console.log(" In " + arguments.callee.name);
	let selectedListIndex = tree.get(PlayerPaths.ACTIVITY_PROPERTY("selectedListIndex"));
	let selectedSectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
	let selectedItemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

	let item = tree.get(["currentChecklist", "children", selectedListIndex, "children", selectedSectionIndex, "children", selectedItemIndex]);

	try {

		if (!item.hasOwnProperty("sketchPadImagePaths") || item.sketchPadImagePaths.length === 0) {
			// console.log("About to save sketch pad for item", item);
			tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "sketchPadImage"), null);
			tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "sketchPadImagePaths"), []);
			tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "sketchPadImagePaths"), null);
		}

		tree.set(["comments", "show"], false);
		tree.set(["comments", "showModeShow"], false);

		//saveCurrentChecklistToStore(tree);
	} catch (e) {
		tree.set(["comments", "show"], false);
		tree.set(["comments", "showModeShow"], false);
	}
}
*/


export function clearSketchPadImage(tree, cb) {
	let selectedListIndex = tree.get(PlayerPaths.ACTIVITY_PROPERTY("selectedListIndex"));
	let selectedSectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
	let selectedItemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "sketchPadImage"), null);
	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "sketchPadImagePaths"), []);
	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "sketchPadImagePaths"), null);

	if (cb) {
		cb();
	}
}


export function showBarcodeScanner(tree) {
	tree.set(PlayerPaths.SHOW_BARCODE_SCANNER, true);
}

export function hideBarcodeScanner(tree, e) {

	let selectedListIndex = tree.get(PlayerPaths.ACTIVITY_PROPERTY("selectedListIndex"));
	let selectedSectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
	let selectedItemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

	const item = tree.get(PlayerPaths.ACTIVITY_ITEM(selectedListIndex, selectedSectionIndex, selectedItemIndex));
	const identityId = tree.get(["user", "identityId"]);

	if (e && e.hasOwnProperty("data") && e.hasOwnProperty("type")) {
		tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "barcode"), e);
		historyActions.setBarcode(tree, selectedListIndex + "," + selectedSectionIndex + "," + selectedItemIndex, e, identityId, item);
	}

	tree.set(PlayerPaths.SHOW_BARCODE_SCANNER, false);
}

export function clearBarcode(tree) {
	// console.log(" In " + arguments.callee.name);

	let selectedListIndex = tree.get(PlayerPaths.ACTIVITY_PROPERTY("selectedListIndex"));
	let selectedSectionIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_SECTION_INDEX);
	let selectedItemIndex = tree.get(PlayerPaths.ACTIVITY_SELECTED_ITEM_INDEX);

	const item = tree.get(PlayerPaths.ACTIVITY_ITEM(selectedListIndex, selectedSectionIndex, selectedItemIndex));
	const identityId = tree.get(["user", "identityId"]);

	tree.set(PlayerPaths.ACTIVITY_ITEM_PROPERTY(selectedListIndex, selectedSectionIndex, selectedItemIndex, "barcode"), "");

	historyActions.clearBarcode(tree, selectedListIndex + "," + selectedSectionIndex + "," + selectedItemIndex, identityId, item);
}


/** PORTED FROM mobile: consolidated logic for submit item value*/


function handleItemTimers(item) {
	const tree = state;
	if (item.startTimer) {
		// startFlightTimer(tree);
	}
	if (item.stopTimer) {
		// stopFlightTimer(tree);
	}
	// if (item.hasOwnProperty("startTracking") && item.hasOwnProperty("stopTracking")) {
	// 	if (item.startTracking !== item.stopTracking) {
	// 		if (item.startTracking) {
	// 			startTrackingLocation();
	// 		} else if (item.stopTracking) {
	// 			stopTrackingLocation();
	// 		}
	// 	}
	// }

	// Loop through any named timers and start them
	let doAdvanceAfterCheck = true;
	if (item.hasOwnProperty("startNamedTimers") && _.isArray(item.startNamedTimers)) {
		for (let i = 0; i < item.startNamedTimers.length; i++) {
			let _startNamedTimer = item.startNamedTimers[i];

			const timerKey = _startNamedTimer.value;
			const objTimer = startNamedTimer(tree, timerKey);
			if (objTimer && objTimer.mode === "modal") {
				doAdvanceAfterCheck = false;
			}
		}
	}

	// Loop through any named timers and start them
	if (item.hasOwnProperty("stopNamedTimers") && _.isArray(item.startNamedTimers)) {
		for (let i = 0; i < item.stopNamedTimers.length; i++) {
			let stopNamedTimer = item.stopNamedTimers[i];

			let timersList = tree.get(["timersList"]);

			for (let j = 0; j < timersList.length; j++) {
				let timerKey = timersList[j];

				let objTimer = tree.get(["timers", timerKey]);

				if (objTimer.guid === stopNamedTimer.value) {
					actionsTimerManager.deleteTimer(tree, timerKey);
				}
			}
		}
	}

	return doAdvanceAfterCheck;
}

function startNamedTimer(tree = state, timerKey) {
	// console.log("Need to start named timer", timerKey);
	let objTimer = null;
	if (timerKey.startsWith("#internal-timer:") || timerKey.startsWith("internal-timer-")) {
		try {
			const id = timerKey.replace("#internal-timer:", "").replace("internal-timer-", "");
			const authorProps = tree.get(["activity", "authorProperties"]);
			const { timers } = authorProps;
			if (timers) {
				_.forEach(timers, timer => {
					if (timer.id === id) {
						objTimer = timer;
					}
				});
			}
		} catch (e) {
			console.warn(e);
		}
	} else {
		objTimer = _.find(tree.get(["timerTemplates"]), (o) => { return o.guid === timerKey; });
	}
	// console.log("Named timer", objTimer, tree.get(["timerTemplates"]));
	if (objTimer) {
		if (objTimer.type === "custom") {
			objTimer = JSON.parse(objTimer.custom);
		}

		let currentChecklist = state.get(["activity"]);
		let context = {};
		if (currentChecklist) {
			const activityId = currentChecklist.id;
			const { selected } = currentChecklist;
			const { listIndex, sectionIndex, itemIndex } = selected;

			context = {
				activityId,
				listIndex,
				sectionIndex,
				itemIndex
			};
		}
		switch (objTimer.type) {
			case "countup": {
				actionsTimerManager.createCountupTimer(tree, objTimer, context);
				break;
			}
			case "countdown":
			default: {
				actionsTimerManager.createCountdownTimer(tree, objTimer, context);
				break;
			}
		}
		return objTimer;
	}
}

function handleChallengeResponseMode(item, listIndex, sectionIndex, itemIndex) {
	const tree = state;
	let checkLabel = tree.get(["checkLabel"]);

	let sayCheck = tree.get(["appPreferences", "voice", "sayCheck"]);
	let voices = tree.get(["appPreferences", "voice", "voices"]);

	if (tree.get(["activity", "selected", "listIndex"]) === listIndex && tree.get(["activity", "selected", "sectionIndex"]) === sectionIndex && tree.get(["activity", "selected", "itemIndex"]) === itemIndex) {
		if (!item.labelOnly) {
			if (!tree.get(["challengeResponseMode"])) {

				if (sayCheck) {
					SyntheticVoiceApi.speak(tree.get(["content"]).mira.responses.check, null, null, { voice: SyntheticVoiceApi.getVoice(voices.secondary) });
				}
			} else {
				SyntheticVoiceApi.setDefaultVoice(voices.secondary);
				SyntheticVoiceApi.speakItem(item, {
					prop: ["label2"]
				});
				SyntheticVoiceApi.setDefaultVoice(voices.primary);

			}
		}
	} else {
		if (!tree.get(["challengeResponseMode"])) {
			const prop = ["label1"];
			if (checkLabel || (item.label2 !== tree.get(["content"]).mira.responses.check)) {
				prop.push("label2");
			}

			// console.log("SPEAK1");
			SyntheticVoiceApi.speakItem(item, {
				prop
			});

			if (sayCheck) {
				// SyntheticVoiceApi.setDefaultVoice(voices.secondary);
				SyntheticVoiceApi.speak(tree.get(["content"]).mira.responses.check, { voice: SyntheticVoiceApi.getVoice(voices.secondary) });
				// SyntheticVoiceApi.setDefaultVoice(voices.primary);
			}
		} else {
			// console.log("SPEAK2");
			SyntheticVoiceApi.speakItem(item, {
				prop: [
					"label1", "label2"
				]
			});
		}
	}
}

function handleSaveOnCheck(item) {
	if (item.hasOwnProperty("saveOnCheck") && item.saveOnCheck) {
		saveActivity(state);
	} else if (item.hasOwnProperty("saveAndExitOnCheck") && item.saveAndExitOnCheck) {
		showConfirm("You are about to be taken back to the home screen, please confirm that this is what you would like to do.", "Leaving Activity", () => {
			saveActivityAndExit();
		});
	}
}

function handlePrintReportOnCheck(item) {
	const tree = state;
	if (item.hasOwnProperty("generateReportOnCheck") && item.generateReportOnCheck && ambifi.persistenceManager && _.isFunction(ambifi.persistenceManager.printInstance)) {
		const currentActivity = _.cloneDeep(tree.get(["activity"]));

		let printFilename = "";
		let lastUpdated = "";
		if (currentActivity.history.length > 0) {
			lastUpdated = currentActivity.history[currentActivity.history.length - 1].timestamp;
		}

		if (lastUpdated !== "") {
			printFilename = currentActivity.name + " - " + lastUpdated;

		} else {
			printFilename = currentActivity.name;
		}
		tree.set(PlayerPaths.SHOW_SPINNER, true);
		ambifi.persistenceManager.printInstance(printFilename, currentActivity, item.generateReportOnCheckTemplate
		).then(() => {
			tree.set(PlayerPaths.SHOW_SPINNER, false);
			//hideSpinner
		}).catch(err => {
			tree.set(PlayerPaths.SHOW_SPINNER, false);
			console.error(err);
			showError("Print Report", "An error occurred while attempting to print the report. Error: " + err);
		});
	}
}


function evalValueTrigger(tree, item) {
	if (item.hasOwnProperty("valueTrigger") && item.valueTrigger !== "") {
		// Inject global procedure functions	
		let strfun = tree.get(PlayerPaths.ACTIVITY_PROPERTY("functions"));
		let strEval = item.valueTrigger;
		if (!_.isEmpty(strfun)) {
			strEval = strfun + "\n" + item.valueTrigger;
		}

		let AmbiFi = RuntimeApi; // eslint-disable-line
		var af = RuntimeApi; // eslint-disable-line
		var afState = state; // eslint-disable-line
		var afUtils = Utils; // eslint-disable-line
		var afSystem = UtilsSystem; // eslint-disable-line
		var afAlert = showAlert; // eslint-disable-line
		eval(strEval);// eslint-disable-line

		//tree.set(["session"], tree.get(["session"]) + 1);
	}
}

function gotoNextForLinks(tree, linkActionType, listIndex, sectionIndex, itemIndex) {
	linkActionType = linkActionType.toLowerCase();
	if (linkActionType === "external" || linkActionType === "opencomments" || linkActionType === "openmedia" || linkActionType === "opennotes" || linkActionType === "opensketchpad") {
		setNextSelected(tree, listIndex, sectionIndex, itemIndex);
	}
}

function submitItemValue(listIndex, sectionIndex, itemIndex, identityId, historyFunc, linkInfo = {}, value, sessionName = null, stopAudio = false) {
	if (stopAudio) {
			SyntheticVoiceApi.stop();
	}

	return new Promise((resolve, reject) => {


		const item = Utils.getItem(state, listIndex, sectionIndex, itemIndex);
		if (!item.enabled) {
			alert("This item is disabled. Please check the mandatory item prior to this.");
			resolve();
			return;
		}
		let treatAsCheckItemWithoutValue = false;
		let checked = true;
		if (_.isPlainObject(value) && value.hasOwnProperty("valueType") && value.valueType === "checkItem") {
			treatAsCheckItemWithoutValue = true;
			if (value.hasOwnProperty("value")) {
				// This is a check item that would like to define the checked state
				checked = _.isBoolean(value.value) ? value.value : false;
			}
		}

		/**
		 * This is an attempt to normalize the value into an array, this way we can spread the values for history purposes
		 */
		let _value = value;
		if (!_.isArray(value)) {
			_value = [value];
		}
		let baseValue = checked;
		if (!treatAsCheckItemWithoutValue) {
			const type = item.type.toLowerCase();
			switch (type) {
				case "itemchoicemulti":
				case "itemranking": {
					baseValue = _value;
					break;
				}
				default: {
					baseValue = _.first(_value);
				}
			}

		}
		console.log("SET ITEM CHECKED", value);

		// Set the item value
		if (!treatAsCheckItemWithoutValue) {
			handleChangeProperty(state, listIndex, sectionIndex, itemIndex, "value", baseValue);
		}
		// Set the item checked
		state.set(["activity", "children", listIndex, "children", sectionIndex, "children", itemIndex, "checked"], checked);
		// Set the items value as a session name, this function will check to see on whether the item is marked for use as a session name
		// Utils.setSessionName(state, listIndex, sectionIndex, itemIndex, sessionName ? sessionName : _.first(value));
		Utils.setSessionName(state, listIndex, sectionIndex, itemIndex, sessionName ? sessionName : value);

		// If a modal timer is launched we don't want to advance right away
		let doAdvanceAfterCheck = true;
		if (checked) {
			// Only do this if the item is checked (submitted)
			doAdvanceAfterCheck = handleItemTimers(item);
			if (item.type === "item") {
				handleChallengeResponseMode(item, listIndex, sectionIndex, itemIndex);
			}
		}

		// This will add the value to the history stack
		if (historyFunc && _.isFunction(historyFunc)) {
			const path = getActivityItemHistoryPath(listIndex, sectionIndex, itemIndex);
			if (item.type === "itemChoiceMulti") {
				historyFunc(state, path, identityId, item, _value);
			} else {
				historyFunc(state, path, identityId, item, ..._value);
			}
		}

		setValueIfHasIdOrchestratedSync(item, baseValue).then(() => {
			// console.log(" In " + arguments.callee.name);
			// console.log("In setItemDateChecked: " + listIndex + "; " + sectionIndex + "; " + itemIndex);
			//tree.set(["currentChecklist", "children", listIndex, "children", sectionIndex, "children", itemIndex, "value"], value);

			setCompletionState(state);

			// Copied this in from setItemChecked
			// TEST
			if (!item.selected) {
				setSelectedItem(state, listIndex, sectionIndex, itemIndex, false);
			}

			refreshMandatory(state);

			evalValueTrigger(state, item);


			/**
			 * LINKING
			 * Need to look at link actions and modal timers
			 * https://ambifi.atlassian.net/wiki/spaces/DEV/pages/309329921/Notes+after+setItemXChecked+Refactor
			 */
			const { linkOnCheck, linkId, linkActionType, canAdvanceOnSelect, linkOnSelect, forceNav, autoAdvancePropName } = linkInfo;

			// canAdvanceOnSelect is true for pickers, when a user chooses a picker item it would automatically move forward.
			if (!canAdvanceOnSelect) {

				if (linkOnCheck) {
					linkUrl(state, linkActionType + ":" + linkId, { listIndex, sectionIndex, itemIndex }, true);
					gotoNextForLinks(state, linkActionType, listIndex, sectionIndex, itemIndex);
				} else if (doAdvanceAfterCheck) {
					setTimeout(() => {
						setNextSelected(state, listIndex, sectionIndex, itemIndex);
					},200);
					//saveCurrentChecklistToStore(tree); 
				}

			} else {
				let li = Utils.getLinkInfo(item, value);

				//setSelectedItem(tree, listIndex, sectionIndex, itemIndex, false);
				if (li.isValidLinkAction && linkOnSelect && !forceNav) {
					linkUrl(state, linkActionType + ":" + linkId, { listIndex, sectionIndex, itemIndex });
					// gotoNextForLinks(tree, linkActionType, listIndex, sectionIndex, itemIndex);
				} else if (doAdvanceAfterCheck) {
					// HCS: Had to add this since a change in the value of this component might lead to UI updates.
					// we saw an issue where navigating to another section that is conditionally hidden causes issues
					// in that the position detection is off. The setTimeout allows the UI to redraw and then the node is
					// found correctly. This might have to be done for all items that potentially set a variable and cause 
					// a calculation for say conditional visibility.


					if (forceNav || (item.hasOwnProperty(autoAdvancePropName) && item[autoAdvancePropName]) || (autoAdvancePropName === "yesNoAdvanceOnSelect" && !item.hasOwnProperty(autoAdvancePropName))) {
						setTimeout(() => {
							setNextSelected(state, listIndex, sectionIndex, itemIndex);
						},200);
					}
					//saveCurrentChecklistToStore(tree); 
				}
			}

			if (checked) {
				// Only do this when the item is checked (submitted)
				handleSaveOnCheck(item);
				handlePrintReportOnCheck(item);
			}
			console.log("ITEM VALUE SUBMITTED");
			resolve();
		}).catch(err => {
			console.error("", err);
			reject(err);
		});
	});

}

export function setLogbookModalVisible(tree, logbookModalVisible) {
	tree.set(["player", "logbookModalVisible"], logbookModalVisible);
}

export function getCurrentContext() {
	let result = null;
	const currentChecklist = state.get(["activity"]);
	if (currentChecklist && currentChecklist.selected) {
		const { listIndex, sectionIndex, itemIndex } = currentChecklist.selected;
		const { id } = currentChecklist;
		result = {
			id,
			listIndex,
			sectionIndex,
			itemIndex
		};
	}
	return result;
}

export function isCurrentContext(id, listIndex, sectionIndex, itemIndex) {
	let result = false;
	const currentContext = getCurrentContext();
	if (currentContext) {
		result = id === currentContext.id && listIndex === currentContext.listIndex && sectionIndex === currentContext.sectionIndex && itemIndex === currentContext.itemIndex;
	}
	return result;
}

export function showPromptGoto(tree, timer, callback) {
	// console.log(" In " + arguments.callee.name);
	//Keyboard.dismiss();

	tree.set(["appState", "promptModalGoto", "timer"], timer);
	tree.set(["appState", "promptModalGoto", "callback"], callback);
	tree.set(["appState", "promptModalGoto", "message"], timer.action.message);
	tree.set(["appState", "promptModalGoto", "visible"], true);

	SyntheticVoiceApi.speak(timer.action.message);
	SyntheticVoiceApi.speak(tree.get(["content"]).alerts.goto);
}


function itemModalVisible(tree = state) {
	return tree.get(["appState", "itemModal", "visible"]);
}

export function showItemModal(tree = state, config, itemId = null) {

	// if (!itemModalVisible()) {
	// if (!config) {
	// 	const result = RuntimeApi.findItemById();
	// 	if (result) {
	// 		const { listIndex, sectionIndex, itemIndex } = result;
	// 		config = _.assign({}, config, {
	// 			listIndex,
	// 			sectionIndex,
	// 			itemIndex,
	// 			itemId
	// 		});
	// 	}
	// } else {
	if (itemId) {
		//Look it up
		const result = RuntimeApi.findItemById(itemId);
		if (result) {
			const { listIndex, sectionIndex, itemIndex } = result;
			config = _.assign({}, config, {
				listIndex,
				sectionIndex,
				itemIndex,
				itemId
			});
		}
	}
	// }

	const _config = _.assign({}, config, { visible: true });
	//console.log("SHOW MODAL ITEM", _config);
	_.keys(_config).forEach(key => {
		tree.set(["appState", "itemModal", key], _config[key]);
	});
	// }
}

export function hideItemModal(tree = state) {
	tree.set(["appState", "itemModal"], { visible: false });
}

export function processListPreferences(tree) {
	tree.set(["dimensions", "listLargestColumnWidth"], tree.get(["dimensions", "defaultListLargestColumnWidth"]));
}

// export async function dismissTour(tourKey) {
// 	const identityId = getIdentityId();
// 	const keyPath = [identityId, "acknowledged", "publication", activityId, version, revision];
// 	console.log("Acknowledge pubs", keyPath.join("_"));
// 	await store.save(keyPath.join("_"), true);
// 	state.set(["releaseNotes", "showModal"], false);
// } 

export async function acknowledgeReleaseNotes(activityId, version, revision) {
	const identityId = getIdentityId();
	const keyPath = [identityId, "acknowledged", "publication", activityId, version, revision];
	console.log("Acknowledge pubs", keyPath.join("_"));
	await store.save(keyPath.join("_"), true);
	state.set(["releaseNotes", "showModal"], false);
}

export async function hasAcknowledgeReleaseNotes(activityId, version, revision) {
	const identityId = getIdentityId();
	const keyPath = [identityId, "acknowledged", "publication", activityId, version, revision];
	const acknowledged = store.get(keyPath.join("_"));
	console.log("Has Acknowledged pubs?", keyPath.join("_"), acknowledged);
	return acknowledged;
}

export async function showReleaseNotes(activityId, version, revision, inventoryEntry) {

	const acknowledged = await hasAcknowledgeReleaseNotes(activityId, version, revision);

	// const inventoryEntry = state.get(["checklistInventoryMap", activityId]);
	if (inventoryEntry && inventoryEntry.publicationRevision && inventoryEntry.publicationRevision === inventoryEntry.revision && inventoryEntry.publicationReleaseNotes && inventoryEntry.publicationReleaseNotes !== "") {
		const releaseNotes = {
			activityId,
			revision: inventoryEntry.publicationRevision,
			version: inventoryEntry.publicationVersion,
			content: inventoryEntry.publicationReleaseNotes
		};
		if (!acknowledged) {
			releaseNotes.showModal = true;
		}
		state.set("releaseNotes", releaseNotes);
	} else {
		state.set("releaseNotes", {
			showModal: false
		});
	}
}

export function showReleaseNotesModal() {
	state.set(["releaseNotes", "showModal"], true);
}


export function showFixedValuesOverlay() {
	state.set(["appState", "fixedValues", "showOverlay"], true);
}


export function hideFixedValuesOverlay() {
	state.set(["appState", "fixedValues", "showOverlay"], false);
}